{
  "brand": {
    "entity": "Heraion",
    "product": "Metria"
  },
  "createHub": {
    "title": "Create",
    "open": "Create",
    "close": "Close",
    "actionsHeader": "Start",
    "todayHeader": "Today",
    "newWorkout": {
      "title": "New workout",
      "sub": "Start a blank workout now"
    },
    "repeatWorkout": {
      "title": "Repeat workout",
      "sub": "Log again from a past workout"
    },
    "buildToday": {
      "title": "Build today's session",
      "sub": "Exercises for the muscles below minimum volume",
      "subInstead": "Instead of today's plan: the muscles below minimum volume"
    },
    "planProgram": {
      "title": "Plan a program",
      "sub": "Build a multi-week training program"
    },
    "planWorkout": {
      "title": "Plan a workout",
      "sub": "Prepare a single session for later"
    }
  },
  "library": {
    "header": "Browse",
    "tabPrograms": "Programs",
    "tabWorkouts": "Workouts",
    "tabPersonal": "Mine",
    "tabCoach": "Coach",
    "tabFavorites": "Favorites",
    "favoriteA11y": "Favorite",
    "errFavorite": "Could not update favorites.",
    "emptyFavoritesTitle": "No favorites yet",
    "emptyFavoritesSub": "Star a program or workout to keep it up here.",
    "sectionOfficial": "By $t(brand.product)",
    "sectionPersonal": "Mine",
    "clone": "Clone",
    "copySuffix": "(copy)",
    "following": "Following…",
    "alreadyYours": "Already yours",
    "cloneFollowed": "Make it yours",
    "followed": "Now following \"{{name}}\".",
    "searchPlaceholder": "Search by name…",
    "filters": "Filters",
    "clearFilters": "Clear",
    "axisLevel": "Level",
    "axisPerWeek": "Sessions / week",
    "noResultsTitle": "No matches",
    "noResultsSub": "Adjust the search or the filters.",
    "loading": "Loading the library…",
    "errLoad": "Could not load the library.",
    "errClone": "Could not clone. Try again.",
    "errDelete": "Could not delete. Try again.",
    "leaveTitle": "Remove from your library?",
    "leaveBody_one": "{{name}} is also assigned to {{count}} other person. They keep it: this only removes it from your library.",
    "leaveBody_other": "{{name}} is also assigned to {{count}} other people. They keep it: this only removes it from your library.",
    "leaveConfirm": "Remove",
    "errLeave": "Could not remove it from your library. Try again.",
    "unfollow": "Stop following",
    "unfollowHint": "Remove it from your library. Its author keeps it.",
    "unfollowTitle": "Stop following?",
    "unfollowBody": "{{name}} stays with its author. This only removes it from your library.",
    "errUnfollow": "Could not stop following. Try again.",
    "errFollow": "Could not follow the program.",
    "errStatus": "Could not update the program.",
    "errAssign": "Could not update assignees.",
    "assignSent": "Sent — everyone new on the list gets a request they can accept or decline.",
    "assignSentSelf": "Sent — since this is coach-authored, check your own athlete inbox to accept or decline it too.",
    "emptyTitle": "Nothing here yet",
    "emptySub": "Programs and workouts you create or clone will show up here.",
    "emptyCoachTitle": "Nothing assigned yet",
    "emptyCoachSub": "No one has assigned you a program or workout yet.",
    "assignedBy": "Assigned by {{name}}",
    "followingVersion": "You're following {{name}}'s version",
    "followingVersionUnknown": "You're following someone else's version"
  },
  "common": {
    "weightUnit_kg": "kg",
    "weightUnit_lb": "lb",
    "lastDataAt": "Last data {{at}}",
    "noData": "No data",
    "lastDataOn": "Last data: {{date}}",
    "languageA11y": "Language",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Discard changes?",
      "body": "You'll lose your unsaved edits.",
      "keepEditing": "Keep editing",
      "discard": "Discard",
      "exitTitle": "Unsaved changes",
      "exitBody": "These changes are not saved. Save them, keep them as a draft on this device, or discard them.",
      "exitBodyNoDraft": "These changes are not saved. Save them or discard them.",
      "save": "Save",
      "keepDraft": "Keep the draft"
    },
    "relativeAge": {
      "today": "today",
      "days": "{{count}}d ago",
      "weeks": "{{count}}w ago",
      "months": "{{count}}mo ago"
    },
    "loadMore": "Load more",
    "loadingMore": "Loading…",
    "pageOf": "{{current}} of {{total}}",
    "weekInProgress": "Week in progress",
    "weekDaysToGo_one": "{{count}} day to go",
    "weekDaysToGo_other": "{{count}} days to go",
    "weekLastDay": "last day",
    "noFullWeekYet": "No full week yet"
  },
  "bodymap": {
    "viewBack": "Back",
    "viewFront": "Front",
    "workedTitle": "Worked muscles",
    "workedPrimary": "primary",
    "workedSecondary": "secondary",
    "heatmapTitle": "Most-trained muscles",
    "heatmapLow": "low",
    "heatmapHigh": "high",
    "window7d": "7 days",
    "window30d": "30 days",
    "painTitle": "Pain map",
    "painHelp": "Tap a muscle to mark it, each side on its own: red (avoid heavy load), yellow (caution). Saved automatically.",
    "painRed": "avoid",
    "painYellow": "caution",
    "painClearAll": "Clear all",
    "painSaving": "Saving…",
    "painSaveError": "Save failed. Check your connection.",
    "painRiskA11y": "Pain risk: {{severity}}",
    "painRiskSideA11y": "Pain risk: {{severity}}, {{side}}",
    "painBannerMuscleSide": "{{muscle}} (<side>{{side}}</side>)",
    "painSideOnly": {
      "left": "left side only",
      "right": "right side only"
    },
    "painSeverity": {
      "red": "high",
      "yellow": "medium",
      "green": "low"
    },
    "painPart": {
      "chest": "your chest",
      "chest_left": "the left side of your chest",
      "chest_right": "the right side of your chest",
      "biceps": "your biceps",
      "biceps_left": "your left biceps",
      "biceps_right": "your right biceps",
      "triceps": "your triceps",
      "triceps_left": "your left triceps",
      "triceps_right": "your right triceps",
      "forearm": "your forearms",
      "forearm_left": "your left forearm",
      "forearm_right": "your right forearm",
      "front-deltoids": "your shoulders",
      "front-deltoids_left": "your left shoulder",
      "front-deltoids_right": "your right shoulder",
      "back-deltoids": "your shoulders",
      "back-deltoids_left": "your left shoulder",
      "back-deltoids_right": "your right shoulder",
      "trapezius": "your traps",
      "trapezius_left": "your left trap",
      "trapezius_right": "your right trap",
      "upper-back": "your upper back",
      "upper-back_left": "the left side of your upper back",
      "upper-back_right": "the right side of your upper back",
      "lower-back": "your lower back",
      "lower-back_left": "the left side of your lower back",
      "lower-back_right": "the right side of your lower back",
      "abs": "your abs",
      "abs_left": "the left side of your abs",
      "abs_right": "the right side of your abs",
      "obliques": "your obliques",
      "obliques_left": "your left oblique",
      "obliques_right": "your right oblique",
      "quadriceps": "your quads",
      "quadriceps_left": "your left quad",
      "quadriceps_right": "your right quad",
      "hamstring": "your hamstrings",
      "hamstring_left": "your left hamstring",
      "hamstring_right": "your right hamstring",
      "gluteal": "your glutes",
      "gluteal_left": "your left glute",
      "gluteal_right": "your right glute",
      "adductors": "your adductors",
      "adductors_left": "your left adductors",
      "adductors_right": "your right adductors",
      "abductors": "your abductors",
      "abductors_left": "your left abductors",
      "abductors_right": "your right abductors",
      "calves": "your calves",
      "calves_left": "your left calf",
      "calves_right": "your right calf",
      "tibialis": "your shins",
      "tibialis_left": "your left shin",
      "tibialis_right": "your right shin",
      "neck": "your neck",
      "neck_left": "the left side of your neck",
      "neck_right": "the right side of your neck",
      "head": "your head",
      "head_left": "the left side of your head",
      "head_right": "the right side of your head"
    },
    "painSummaryAvoid": "Avoid: {{parts}}",
    "painSummaryCaution": "Caution: {{parts}}",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomReset": "Reset zoom",
    "zoomPinchHint": "Pinch or use the buttons.",
    "painListToggle": "Muscles as a list",
    "painListLeft": "{{muscle}} (left)",
    "painListRight": "{{muscle}} (right)",
    "painStateRed": "Avoid heavy load",
    "painStateYellow": "Caution",
    "painStateNone": "Not marked",
    "painListRowA11y": "{{muscle}}, {{state}}"
  },
  "plates": {
    "title": "Plate breakdown",
    "openHint": "Show plate breakdown",
    "close": "Close",
    "targetLabel": "Target",
    "barLabel": "Bar",
    "barAria": "Barbell weight",
    "barNone": "No bar",
    "perSide": "Per side",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Just the bar — no plates needed.",
    "belowBar": "Target is lighter than the bar.",
    "invalidInput": "Enter a valid weight first.",
    "remainder": "+{{weight}} short of target with the current inventory.",
    "fallbackPill": "closest possible",
    "inventoryLegend": "Pairs available",
    "inventoryHint": "Pairs of each plate available right now. Set to 0 if the gym doesn't have it or the rack is empty. Saved across sessions.",
    "pairsAria": "Pairs of {{plate}} available",
    "loadedSide": "Loaded side",
    "singleSideHint": "One side only: the plates go on a single side. Landmine, T-bar, sleds and per-arm levers load this way."
  },
  "app": {
    "title": "$t(brand.product)",
    "tagline": "Strength training, logged plain.",
    "signedInAs": "Signed in as <bold>{{email}}</bold>.",
    "signOut": "Sign out",
    "loading": "Loading…",
    "checking": "checking…"
  },
  "auth": {
    "signIn": "Sign in",
    "signInFailed": "Sign-in failed. Check your email and password.",
    "email": "Email",
    "emailPlaceholder": "email@example.com",
    "password": "Password",
    "passwordRules": {
      "length": "At least 10 characters",
      "uppercase": "One capital letter",
      "lowercase": "One small letter",
      "number": "One number",
      "met": "done",
      "unmet": "still missing"
    },
    "revealPassword_one": "Show password",
    "revealPassword_other": "Show passwords",
    "hidePassword_one": "Hide password",
    "hidePassword_other": "Hide passwords",
    "passwordHint": "At least 10 characters with upper, lower, and a number.",
    "invitedOnly": "Accounts are created by invitation. If you were invited, sign in with the address and the temporary password you received by email.",
    "submitting": "Working…",
    "confirmTitle": "Confirm your email",
    "confirmHelp": "We sent a code to <bold>{{email}}</bold>. Paste it below to finish creating the account.",
    "confirmCode": "Confirmation code",
    "confirmSubmit": "Confirm",
    "confirming": "Confirming…",
    "resendCode": "Resend code",
    "resentInfo": "Code resent. Check your inbox.",
    "confirmedNowSignIn": "Account confirmed. Sign in to continue.",
    "forgotEmailRequired": "Type the email you sign in with.",
    "forgotCodeRequired": "Type the code we sent you.",
    "forgotLink": "Forgot your password?",
    "forgotTitle": "Reset your password",
    "forgotIntro": "Enter your email and we will send you a code to reset the password.",
    "forgotSendCode": "Send code",
    "forgotCodeSent": "Code sent. Check your inbox.",
    "forgotConfirmHelp": "We sent a code to <bold>{{email}}</bold>. Type it below.",
    "forgotResetSubmit": "Reset password",
    "forgotResetDone": "Password updated. Sign in with the new one.",
    "newPassword": "New password",
    "backToSignIn": "Back to sign in",
    "welcome": {
      "title": "Welcome to $t(brand.product)",
      "help": "You were invited. Choose the password you'll use from now on, and tell us what to call you.",
      "name": "What should we call you?",
      "namePlaceholder": "Your name",
      "nameRequired": "Give us a name — it's how the app will greet you.",
      "submit": "Enter"
    },
    "confirmPassword": "Confirm password",
    "passwordsMatch": "The two match.",
    "passwordMismatch": "The two passwords don't match.",
    "forgotCodeSubmit": "Continue",
    "forgotCodeIncomplete": "Type all six digits of the code.",
    "forgotPasswordHelp": "Choose the password you'll use from now on.",
    "backStep": "Back",
    "forgotStep": "Step {{n}} of 3",
    "forgotCodeWrong": "That code isn't right. Check it and try again.",
    "forgotCodeExpired": "That code has expired. Ask for a new one.",
    "forgotTooManyAttempts": "Too many attempts. Wait a few minutes and try again.",
    "forgotTooManyRequests": "Too many codes requested. Wait a few minutes.",
    "resendCodeIn": "Resend code ({{seconds}}s)"
  },
  "dashboard": {
    "meTitle": "Authenticated round-trip — /api/me",
    "healthTitle": "API health",
    "exportData": "Export my data",
    "deleteAccount": "Delete my account",
    "exporting": "Preparing export…",
    "deleting": "Deleting…",
    "deleteConfirm": "This will permanently delete your account and all your data. Type DELETE to confirm.",
    "deleteCancel": "Cancel",
    "deletePlaceholder": "DELETE",
    "deleteSuccess": "Account deleted.",
    "exportFilename": "metria-export-{{date}}.json",
    "privacyTitle": "Privacy",
    "privacyHelp": "Export everything as JSON or wipe the account end to end. Deletes are permanent."
  },
  "privacy": {
    "linkLabel": "Privacy",
    "title": "Privacy notice",
    "lastUpdated": "Last updated: 9 September 2026 (who is responsible, retention, Health Connect, coaches)",
    "intro": "Metria is a training app published under the name Heraion by Antenore Gatta, in Switzerland. Heraion is not a registered company: the person responsible for your data is a private individual, and that is who you are dealing with. This notice explains what we collect, why, where it is stored, how long it stays and what you can ask us to do about it.",
    "section1Title": "What we collect",
    "section1Body": "Only what the app needs in order to work, plus what you choose to put into it. To hold an account: your email address, which is also the account identifier, and a password, which Amazon Cognito keeps only as a cryptographic hash — the plaintext never reaches us. On your profile: a display name, which is required and may well be a nickname rather than your legal name, and, if you fill them in, an age bracket and biological sex, which the app uses for the body-fat formulas and for the body figure it draws. Then everything you enter as you train: workouts, sets, loads, programmes, notes, personal records, and, if you use those parts of the app, body measurements, bodyweight, pain markers and health values. We do not ask for your postal address, your telephone number, your date of birth or any payment details, and we run no analytics, no advertising and no tracking, so there is no behavioural profile of you anywhere. Bodyweight, body measurements, pain markers and anything read from Health Connect are health data — special-category data under Article 9 GDPR and sensitive personal data under Article 5 letter c of the Swiss data protection act — so they are never aggregated, never written into our logs, and they go when your account goes.",
    "section2Title": "Where it lives, and who else touches it",
    "section2Body": "All data is stored in the AWS region eu-central-2 (Zurich, Switzerland). Amazon Web Services is the only processor we use: authentication runs on Amazon Cognito, structured data on Amazon DynamoDB, the server code on AWS Lambda, and the static files of the app are served through Amazon CloudFront. We use no analytics, advertising or tracking services of any kind, we do not sell or rent your data, and we do not hand it to anybody else. The only two ways your data travels further are the two you switch on yourself: Health Connect on your phone, and a coach you invite. Each has its own section below.",
    "section3Title": "Your rights",
    "section3Body": "From inside the app you can export your entire data set as JSON, and you can delete your account permanently; deletion removes your authentication record and everything stored under your account, with no soft-delete kept behind it. Beyond those two buttons you have the rights the law gives you: to know what we hold about you, to have it corrected, to have it erased, to receive a copy in a portable format, to object to a processing or ask that it be restricted, and to withdraw a consent you have given — withdrawing it stops us going on, and does not make unlawful what was done while it stood. Write to {{email}} and a person will answer. If you believe we have handled your data wrongly you can also complain to a supervisory authority: in Switzerland the Federal Data Protection and Information Commissioner, in the European Union the authority of the country where you live.",
    "section4Title": "Who is responsible, and how to reach us",
    "section4Body": "The controller of your data is Antenore Gatta, who publishes Metria under the name Heraion from Switzerland. Heraion is a project name, not a registered company, so the responsibility here is personal rather than corporate. Questions, requests and complaints: {{email}}.",
    "section5Title": "Legal basis",
    "section5Body": "Your account and your training data are processed in order to provide the service you asked for — the performance of the agreement between us, Article 6(1)(b) GDPR, and the same purpose under the Swiss data protection act. Health data — bodyweight, body measurements, pain markers and anything read from Health Connect — is processed only on your explicit consent, Article 9(2)(a) GDPR, which you give by switching that part of the app on and can withdraw by switching it off or deleting the data. We do not stretch legitimate interest to cover anything you would not expect, and we will update this notice before any new purpose is added.",
    "section6Title": "Who can use Metria",
    "section6Body": "Metria is not intended for children. You must be at least 13 years old to hold an account, or older where the law of your country requires a higher age. Below that age, a parent or legal guardian must agree on your behalf and supervise the use. Accounts are not opened by public sign-up: somebody already in Metria invites you and the account is created for you, so an invitation addressed to a minor has to be accepted by their parent or legal guardian.",
    "section7Title": "How long we keep it, and what deletion removes",
    "section7Body": "While your account exists, what you entered stays: we do not expire your history and we do not move it elsewhere when you stop training. Some things are deliberately shorter. When you delete a workout, a marker takes its place for 30 days so that a device which was offline learns the session is gone, and then the marker goes too. A cache that keeps a request from being applied twice holds its entry for 24 hours. Our database is backed up continuously and can be restored to any point in the previous 35 days, so a record you deleted can still exist inside a backup for that long before it is beyond recovery — we restore a backup only to repair a failure, never to bring back an account somebody deleted. Deleting your account removes your authentication record and every record stored under it, including what was imported from Health Connect and the coach link on both sides of it; once the backup window has passed, nothing of it is left. One thing is deliberately kept and detached rather than deleted: a feedback report you sent us from inside the app remains, because it describes the app rather than you, but who wrote it is removed from it.",
    "section8Title": "Health Connect",
    "section8Body": "On Android, Metria can connect to Health Connect. It is off until you turn it on in Settings, Health Connect asks you to grant each kind of data separately, and the app works without it. When it is on, Metria reads your workouts together with their heart rate, active calories and distance, so a session recorded by your watch appears in your timeline with its effort; your bodyweight, body fat and lean body mass, so the body section shows one history instead of two; and your blood glucose and nutrition entries, so the metabolic card can put today's carbohydrates and your glucose readings next to your training. Metria writes back two things, and only ones you entered here yourself: a bodyweight and a blood glucose reading, so a value you typed into Metria is not stranded inside Metria. What we read leaves your phone: it is stored on our servers in Zurich with the rest of your data and under the same rules — never used for advertising, never sold, never passed to a third party, never used to train any model. It stays until you delete it or your account, as described in the section above. You can disconnect from Metria's settings or revoke the permissions in Health Connect itself at any time; either one stops further reading, and the values already imported remain yours to delete inside Metria.",
    "section9Title": "If you have a coach",
    "section9Body": "Metria can link an athlete and a coach. The link starts with an invitation addressed to an email address, which we store on the invitation so that only the person holding that address can accept it, and which is cleared once the link becomes active. While the link is active the coach can read the athlete's training side — sessions and their results, programmes and targets, maxes and records, and the profile — and can change nothing unless the athlete has granted the right to set targets; a coach cannot grant that to themselves. Either side can end the link from the app at any time, and ending it stops the access. Inviting an athlete below the age in the section above requires the agreement of a parent or legal guardian: that agreement is the responsibility of the person sending the invitation, and Metria neither asks for it nor verifies it.",
    "back": "Back"
  },
  "terms": {
    "linkLabel": "Terms",
    "title": "Terms of use",
    "lastUpdated": "Last updated: 9 September 2026 (who we are, how you accept, languages)",
    "intro": "These terms are the agreement between you and us for the use of Metria. By using the app you accept them. If you do not accept them, please do not use Metria.",
    "section1Title": "Who we are",
    "section1Body": "Metria is published under the name Heraion by Antenore Gatta, in Switzerland. Heraion is the name of the project, not a registered company: the person you are contracting with is a private individual. You can reach us at {{email}}.",
    "section2Title": "These terms",
    "section2Body": "Accounts are not opened by public sign-up: somebody already in Metria invites you, and the account is created for you. By using Metria once the account exists — signing in, entering a workout — you accept these terms, and they become the agreement between you and us. If you do not accept them, do not use Metria and ask us to delete the account. Where you are a consumer, nothing written here takes away a right that the law of your country gives you and that cannot be waived.",
    "section3Title": "Who can use Metria",
    "section3Body": "You must be at least 13 years old to hold an account, or older where the law of your country requires a higher age. Below that age, a parent or legal guardian must accept these terms on your behalf and supervise the use. An account is personal: keep your password to yourself, and tell us if you believe someone else has it.",
    "section4Title": "Metria is not medical advice",
    "section4Body": "Metria is a training tool. It is not a medical device and it does not give medical advice. The weights, repetitions and rest times it shows are suggestions computed from the numbers you entered, not a prescription: you decide what you lift, and you train at your own risk. Strength training can cause injury. If you have a medical condition or an injury, if you are pregnant, or if you are coming back after a long break, speak to a doctor before you start — and stop when something hurts. Any pain marker, body measurement or health value the app displays, including anything imported from Health Connect, is a record of what you or your device entered, never a diagnosis: Metria neither detects nor monitors any medical condition.",
    "section5Title": "What you enter stays yours",
    "section5Body": "The workouts, programmes, measurements and notes you enter belong to you. To operate the service we need a limited licence to store, back up, process and display them — to you, and to the people you have chosen to share them with. Nothing more, and it ends when you delete the data or the account. What we collect and why is in the privacy notice.",
    "section6Title": "Coaches and athletes",
    "section6Body": "If you invite someone as their coach, you must have their agreement first, and their agreement to what you will be able to see. Their data stays theirs: your access depends on the role they hold in the app and they can withdraw it. If the athlete is below the age in the section above, you must have the agreement of their parent or legal guardian before you invite them.",
    "section7Title": "Fair use",
    "section7Body": "Use Metria lawfully. Do not try to reach accounts, data or parts of the service that are not yours, do not scrape or resell it, do not upload unlawful content, and do not enter another person's data without their agreement.",
    "section8Title": "Price",
    "section8Body": "Metria is free today. If we introduce paid features we will say so clearly and in advance, and billing will run through Apple's or Google's store, whose rules govern payment, renewal and refunds. Digital content that begins immediately at your request may carry no right of withdrawal; where the law gives you one, you keep it.",
    "section9Title": "Availability and changes",
    "section9Body": "We provide Metria as it is and as it is available: we do not promise that it will be uninterrupted or free of errors. We may add, change or remove features, and before a change that materially reduces something you rely on we will tell you inside the app.",
    "section10Title": "Ending it",
    "section10Body": "You can stop at any time: delete your data or your account from within the app. We may suspend or close an account that breaks these terms or that we are required by law to close, and unless it would be unlawful or unreasonable we will tell you why first. Deleting your account removes your data as described in the privacy notice.",
    "section11Title": "Liability",
    "section11Body": "We are liable for damage caused by our intent or gross negligence, for injury to life, body or health, and for anything else the law does not permit us to exclude — your mandatory consumer rights included. Beyond that we are not liable for indirect or unforeseeable loss, for injury arising from training you chose to do, or for data lost because it was never exported.",
    "section12Title": "Apps from Apple and Google",
    "section12Body": "If you use the iOS app, this agreement is between you and us and not with Apple. Apple is not responsible for the app or for any claim relating to it and provides no support for it; Apple and its subsidiaries may enforce this agreement as third-party beneficiaries. If you use the Android app, the rules of the store you installed it from apply alongside these terms.",
    "section13Title": "Changes to these terms",
    "section13Body": "We may change these terms. The new version is published here with its date, and for changes that matter to you we will say so inside the app before they take effect. If you keep using Metria after that, the new version applies.",
    "section14Title": "Law and disputes",
    "section14Body": "Swiss law applies. If you are a consumer you also keep the protection of the mandatory rules of the country where you live, and you may bring proceedings before the courts of that country. Consumers in the European Union can also use the European online dispute resolution platform at ec.europa.eu/consumers/odr.",
    "section15Title": "Languages",
    "section15Body": "These terms are published in English, Italian, French, German and Russian. English is the language they were drafted in and the version that prevails if a translation says something different — except where the law of your country gives the version in your own language precedence, in which case that version applies to you. The privacy notice is published in the same five languages, on the same footing.",
    "back": "Back"
  },
  "errors": {
    "generic": "Something went wrong."
  },
  "feedback": {
    "title": "Send feedback",
    "help": "Found a bug, want a feature, or have something else to share? Send a note here. Submissions land in the admin inbox.",
    "kindLabel": "Type",
    "kind_bug": "Bug",
    "kind_feature": "Feature request",
    "kind_other": "Other",
    "kind_crash": "Crash report",
    "bodyLabel": "What happened?",
    "bodyPlaceholder": "Describe what you saw, what you expected, and how to reproduce.",
    "send": "Send",
    "sending": "Sending…",
    "sentFlash": "Thanks — sent.",
    "sentHint": "We'll triage it next session. You can close this now.",
    "close": "Close",
    "errEmpty": "Write something before sending.",
    "errSubmit": "Couldn't send. Try again in a moment.",
    "errRateLimit": "Too many submissions in the last hour. Try again later.",
    "inboxTitle": "Feedback inbox",
    "loading": "Loading feedback…",
    "empty": "No feedback to show.",
    "filterAll": "All",
    "loadMore": "Load more",
    "status_open": "Open",
    "status_in_progress": "In progress",
    "status_shipped": "Shipped",
    "status_wontfix": "Won't fix",
    "priorityLabel": "Priority",
    "priorityNone": "None",
    "statusLabel": "Status",
    "head_open": "{{count}} open",
    "head_in_progress": "{{count}} in progress",
    "head_shipped": "{{count}} shipped",
    "head_wontfix": "{{count}} won't fix",
    "headTotal": "{{count}} total"
  },
  "profile": {
    "title": "Profile",
    "loading": "Loading profile…",
    "name": "Display name",
    "namePlaceholder": "How should we call you?",
    "role": "Role",
    "roleCoach": "Coach",
    "roleAthlete": "Athlete",
    "roleBoth": "Both",
    "ageBucket": "Age range (optional)",
    "ageBucketHelp": "Used only for opt-in anonymous group statistics. Stays empty if you skip it.",
    "ageBucketNone": "Prefer not to say",
    "unitsPreference": "Preferred unit",
    "unitsPreferenceHelp": "We always store weights in kilograms. Each workout entry can override the unit on input.",
    "preferredFigure": "Body figure on the bodymap",
    "preferredFigureHelp": "Choose the figure your muscle maps show.",
    "figure_masculine": "Masculine",
    "figure_feminine": "Feminine",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Profile saved.",
    "agePrefix_under_18": "Under 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Bodyweight (optional)",
    "bodyweightPlaceholder": "e.g. 78",
    "bodyweightHelp": "Used only to compute the effective load on bodyweight exercises. Never aggregated, never logged, wiped on account delete.",
    "errBodyweight": "Enter a bodyweight between 20 and 300 kg (or the equivalent in lb).",
    "apk": {
      "title": "Android APK (test build)",
      "hint": "Family-only test build. Install on Android by enabling \"Install from unknown apps\" in your browser, then opening the file.",
      "download": "Download APK"
    },
    "email": "Email",
    "metaTitle": "Session"
  },
  "workout": {
    "title": "Workouts",
    "loading": "Loading workouts…",
    "empty": "No workouts logged yet.",
    "logNew": "Log workout",
    "startedAt": "When",
    "exercise": "Exercise",
    "exercisePlaceholder": "Pick an exercise",
    "errPickExercise": "Pick an exercise from the catalog.",
    "catalogEmptyCoach": "The catalog is empty. Add at least one exercise before logging a workout.",
    "catalogEmptyAthlete": "The catalog is empty. One of your coaches has to add exercises before you can log a workout.",
    "setsLegend": "Sets",
    "set": "Set",
    "reps": "Reps",
    "amrapHint": "AMRAP — push past the prescribed floor",
    "weight": "Weight",
    "extra": "Extra (+/−)",
    "unit": "Unit",
    "rpe": "RPE",
    "addSet": "Add set",
    "removeSet": "Remove set",
    "notes": "Notes (optional)",
    "setNoteToggle": "Add a note to this set",
    "setNotePlaceholder": "What was different about this set",
    "prefillFromDate": "Prefill from {{date}}?",
    "prefillAccept": "Use it",
    "savePromptTitle": "Check before saving",
    "savePromptContinue": "Back to workout",
    "savePromptAnyway": "Save anyway",
    "unmarkedPromptBody": "{{count}} sets have data but no completion mark.",
    "unmarkedPromptFail": "Mark as failed and save",
    "unmarkedPromptComplete": "Mark as done and save",
    "outlierPromptBody": "{{count}} entries look unusual:",
    "outlierItem": "{{exercise}}: {{weight}} (history max {{expected}})",
    "outlierE1rmItem": "{{exercise}}: implied 1RM {{e1rm}} (history max {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} is ~double your usual {{expected}} — did you enter the weight of ONE implement, or the total of both?",
    "outlierRepsItem": "{{exercise}}: {{reps}} reps — looks too high",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} reps with no weight",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Workout saved.",
    "savedEdit": "Workout updated.",
    "deleted": "Workout deleted.",
    "cancel": "Cancel",
    "errNoSets": "Add at least one valid set.",
    "creatingTitle": "New workout",
    "editingTitle": "Edit workout",
    "exerciseN": "Exercise {{n}}",
    "addExercise": "Add another exercise",
    "removeExercise": "Remove exercise",
    "removeExerciseConfirm": "Remove {{name}} from this workout? Any logged sets on it will be lost.",
    "groupAlignTitle": "Different set counts",
    "groupAlignBody": "Members of this group have between {{shortest}} and {{longest}} sets. Align them so the rounds line up?",
    "groupAlignPad": "+ Pad to {{n}}",
    "groupAlignTrim": "− Trim to {{n}}",
    "groupAlignTrimWarning": "Trimming deletes sets that are already logged, and cannot be undone.",
    "groupAlignTrimHint": "Deletes the extra sets from every member of the group. Cannot be undone.",
    "groupAlignKeep": "Keep as is",
    "splitGroup": "Split",
    "splitGroupTitle": "Split this group?",
    "splitGroupBody": "Members keep their sets and stay in the workout, just unlinked. You can re-group them anytime.",
    "splitGroupConfirm": "Split",
    "removeRoundConfirmTitle": "Remove this round?",
    "removeRoundConfirmBody": "Round {{n}} of {{names}} will be dropped together.",
    "bilateral": "Bilateral",
    "unilateral": "Unilateral",
    "edit": "Edit",
    "repeat": "Repeat",
    "delete": "Delete",
    "deleting": "Deleting…",
    "deleteConfirm": "Delete this workout?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Duration",
    "cardioDistance": "Distance",
    "cardioWeight": "Weight",
    "cardioHr": "Avg HR",
    "cardioCalories": "Calories",
    "cardioOptionalsShow": "Other fields",
    "cardioOptionalsHide": "Other fields",
    "dateEditor": "Date & duration",
    "dateLabel": "Date",
    "startTimeLabel": "Start",
    "endTimeLabel": "End",
    "durationLabel": "Duration",
    "side": "Side",
    "sideLeft": "Left",
    "sideRight": "Right",
    "sideBoth": "Both",
    "showRpe": "Track RPE",
    "showDuration": "Track duration",
    "rir": "RIR {{n}}",
    "swap": "Swap",
    "swapHint": "Bench taken? Pick a similar exercise.",
    "descriptionToggle": "Show / hide description",
    "failShort": "F",
    "failToggle": "Mark set as failed",
    "failHint": "Last rep missed. Counts in volume, excluded from PR.",
    "startRest": "Start rest timer",
    "restStartDefault": "Start rest ({{n}}s)",
    "restStartCustom": "Start rest ({{n}}s, exercise default)",
    "setComplete": "Mark set complete",
    "setCompleteHint": "Stamp this set as done and start a {{n}}s rest.",
    "setCompleteHintCustom": "Stamp this set as done and start a {{n}}s rest (exercise default).",
    "setUndo": "Undo set completion",
    "setUndoHint": "Tap again to undo and reset the rest timer.",
    "restLeft": "Rest",
    "restDone": "Time's up",
    "restStop": "Stop",
    "restPause": "Pause",
    "restResume": "Resume",
    "restSound": "Beep at end of rest",
    "instructions": "Coach instructions (optional)",
    "instructionsPlaceholder": "Focus for the session, what to skip if time-pressed, intent.",
    "lastTime": "Last",
    "lastToday": "today",
    "lastDaysAgo": "{{n}}d ago",
    "dropsetShort": "Drop",
    "dropsetToggle": "Add a dropset chain",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variant",
    "dropsetClassical": "Classical (drop weight)",
    "dropsetMyorep": "Myo-rep (same load)",
    "dropsetHintClassical": "Lower the load 10–30% and chase reps to fatigue. No rest.",
    "dropsetHintMyorep": "Same load, fewer reps, 10–20s breath, repeat.",
    "dropsetSameLoad": "= top",
    "dropsetAddStep": "Add drop",
    "dropsetRemove": "Remove",
    "dropsetRemoveConfirm": "You have {{n}} drop steps. Convert back to a working set and discard them?",
    "dropsetRemoveStep": "Remove drop",
    "groupLabel": "Group",
    "groupNone": "(none)",
    "groupCreate": "Create new",
    "groupNewSuperset": "New superset",
    "groupNewCircuit": "New circuit",
    "groupJoinExisting": "Join an existing group",
    "groupLeave": "Ungroup",
    "groupSharedHint": "Shared. Open another exercise and pick the same group from this dropdown to pair them.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Circuit {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Detected from alternating sets in this session",
    "playActiveTitle": "Active exercise — most recent completed set",
    "errGroupKindMixed": "A single group can't mix superset and circuit. Pick one kind.",
    "exerciseNew": "New exercise",
    "cardMenu": "Exercise options",
    "menuReplace": "Replace exercise",
    "menuGroup": "Group / superset",
    "menuMoveUp": "Move up",
    "menuMoveDown": "Move down",
    "menuShowNotes": "Show notes",
    "menuHideNotes": "Hide notes",
    "menuShowDescription": "Show description",
    "menuHideDescription": "Hide description",
    "tipAlternatives": "Alternative exercises",
    "tipCoachNote": "Coach note",
    "perImplementHint": "Using two, or one side at a time? Log the weight of just one. The app counts both (×2).",
    "tipProgramNote": "In this program",
    "tipNoAlternatives": "No similar exercises in the catalog",
    "tipClose": "Close",
    "painBanner": {
      "red": "Stresses a painful muscle",
      "yellow": "Caution: loads a flagged muscle",
      "green": "No pain risk"
    },
    "setCycleHint": "Tap: done · again: failed · again: undo",
    "setStatePending": "Set pending",
    "setStateDone": "Set completed",
    "setStatePr": "Set completed, personal record",
    "setStateFailed": "Set marked failed",
    "prShort": "🏆",
    "addDrop": "+ drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "CIRCUIT",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Lock",
    "groupAutoConfirmAria": "Lock the group: stop the detector and keep these exercises tied together",
    "groupAutoDismissAria": "Ignore the detection: split these back into solo exercises",
    "groupAddSetAll": "Add a set to every member",
    "nameLabel": "Name (optional)",
    "namePlaceholder": "e.g. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "duration stepper",
    "rirLabel": "RIR",
    "showRir": "Track RIR",
    "maxDownA11y": "MAX may have dropped",
    "animationOf": "Animation of {{name}}",
    "animationZoomHint": "Opens the animation full screen",
    "closeAnimation": "Close the animation",
    "showAnimation": "Show the animation",
    "showBodyMap": "Show the muscles worked",
    "pagerDot": "{{target}}, {{current}} of {{total}}",
    "pagePrev": "Previous page",
    "pageNext": "Next page",
    "editUnsupportedTitle": "Edit not supported yet",
    "editUnsupportedBody": "This workout contains exercise types (P1RM, loaded carry) the logger can't edit yet."
  },
  "program": {
    "title": "Programs",
    "help": "Multi-week training cycles. Phase 5.1 ships the shell — name, weeks, sessions per week. The slot and progression builder lands next.",
    "new": "New program",
    "newTitle": "New program",
    "name": "Name",
    "namePlaceholder": "e.g. Powerbuilding 6-week",
    "cycleWeeks": "Cycle weeks",
    "sessionsPerWeek": "Sessions per week",
    "description": "Description",
    "descriptionPlaceholder": "What this cycle is for, who it's aimed at, any notes for the athletes.",
    "create": "Create",
    "creating": "New program: {{name}}",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleteConfirm": "Confirm?",
    "deleteConfirmYes": "Yes, delete",
    "loading": "Loading programs…",
    "empty": "No programs yet. Create one to plan a multi-week cycle.",
    "statusDraft": "Draft",
    "statusActive": "Active",
    "statusArchived": "Archived",
    "cycleWeeksLabel": "{{n}}-week cycle",
    "sessionsPerWeekLabel": "{{n}}× / week",
    "slotCount": "{{n}} slot(s)",
    "skeletonHint": "Skeleton only. Slots get filled in the next phase.",
    "sessionDefaultName": "Session {{n}}",
    "edit": "Edit",
    "editing": "Editing: {{name}}",
    "assign": "Assign",
    "backToList": "Back to programs",
    "save": "Save",
    "saving": "Saving…",
    "errSave": "Could not save the program.",
    "metaLegend": "Program",
    "status": "Status",
    "metaCyclesLive": "Structural edits (days, weeks) apply as you make them",
    "ordinalSession": "{{n}}ª session",
    "sessionName": "Session name",
    "slotN": "Slot {{n}}",
    "addSlot": "Add slot",
    "removeSlot": "Remove",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "exercise": "Exercise",
    "exercisePick": "Pick an exercise",
    "setsLegend": "Sets",
    "addSet": "Add set",
    "removeSet": "Remove set",
    "reps": "Reps",
    "setNotesPlaceholder": "Per-set note (optional)",
    "set": "Set",
    "intensityKind": "Intensity",
    "intensityNone": "None (athlete picks)",
    "intensityPercent": "% of MAX",
    "intensityAbs": "kg (absolute)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Percentage",
    "intensity_absolute": "Weight (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "W{{n}}",
    "previewShow": "Preview",
    "previewHide": "Hide preview",
    "previewMuscles": "Muscles touched",
    "previewSets": "{{n}} sets",
    "previewEmptySession": "No slots in this session.",
    "previewEmptyProgram": "No slots yet. Open Edit to add some.",
    "start": "Start session",
    "startCancel": "Cancel",
    "startGo": "Start",
    "starting": "Starting…",
    "startWeek": "Week",
    "startSession": "Session",
    "progressNext": "Next: W{{w}} · Session {{s}}",
    "instructions": "Instructions",
    "instructionsPlaceholder": "Tempo, pause length, technique focus, RPE target.",
    "amrapLastSet": "AMRAP on last set",
    "maxAttempt": "1MAX attempt",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Applied across {{n}} weeks of the cycle.",
    "catalogLoading": "Loading the exercise catalog…",
    "builderComingSoon": "The slot and progression builder lands in Phase 5.2. For now, this creates an empty shell you can delete or fill later.",
    "errCycleWeeks": "Cycle weeks must be between 1 and 12.",
    "errSessionsPerWeek": "Sessions per week must be between 1 and 7.",
    "errName": "Program name is required.",
    "errSchema": "Invalid program data.",
    "errCreate": "Could not create program.",
    "errCode": {
      "sessionNameEmpty": "Every training day needs a name.",
      "slotNoExercise": "Pick an exercise for every slot.",
      "slotNoSets": "Every exercise needs at least one set.",
      "slotAllWeeksInactive": "An exercise is off on every week. Switch on a week or remove it.",
      "rowWidthMismatch": "A set row doesn't match the number of weeks. Reopen the exercise and try again.",
      "invalidReps": "Check the reps: use a number like 8, or 8+ for AMRAP.",
      "groupKindMixed": "A superset mixes set types. Give its exercises the same type.",
      "schemaInvalid": "Invalid program data.",
      "noSession": "There's no workout to save.",
      "planNameEmpty": "Plan name is required.",
      "planNoExercises": "Add at least one exercise to the plan.",
      "invalidIntensityValue": "Check the intensity value: it should be a number.",
      "weightOutOfRange": "That weight is out of range.",
      "pctOutOfRange": "The percentage must be between 0 and 200.",
      "rpeOutOfRange": "RPE must be between 1 and 10.",
      "rirOutOfRange": "RIR must be between 0 and 10.",
      "unknownIntensityKind": "Unknown intensity type.",
      "invalidSeconds": "Check the seconds: a timed set needs a length, in whole seconds up to 3600.",
      "invalid_email": "That email looks malformed.",
      "email_not_found": "No account found with that email.",
      "too_many_assignees": "Up to 20 people per program.",
      "programNameEmpty": "Program name is required.",
      "sessionEmpty": "Every training day needs at least one exercise.",
      "sessionTooManyExercises": "A training day can hold at most 20 exercises.",
      "amrapWithTime": "A timed set cannot also be AMRAP. Remove one of the two.",
      "client_outdated": "Update the app to save this program.",
      "invalidRepsRange": "Check the rep range: a low and a high end around the target, like 8-12 around 10."
    },
    "cardMenu": "Slot menu",
    "menuGroup": "Group",
    "groupNone": "No group",
    "groupJoinExisting": "Join existing",
    "groupCreate": "Create",
    "groupNewSuperset": "New superset",
    "groupNewCircuit": "New circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "assignTo": "Assign to athletes",
    "assignToHelp": "Assigning is an offer: it reaches their library only if they accept, and what they accepted stays theirs if you remove them. Needs an active coach edge with you first.",
    "assignSelf": "You (creator)",
    "addAssignee": "Add",
    "removeAssignee": "Remove",
    "removeAssigneeConfirm": "Remove access?",
    "removeAssigneeHint": "They'll lose this from their library. Tap again to remove.",
    "pendingAssigneeCaption": "Pending",
    "rosterSectionLabel": "From your roster",
    "rosterEmpty": "No athletes in your roster yet.",
    "rosterAllAssigned": "Everyone in your roster is already assigned.",
    "shareTo": "Share with",
    "shareToHelp": "Sharing sends an offer: it reaches their library only if they accept, and what they accepted stays theirs if you remove them.",
    "shareSectionLabel": "People you can share with",
    "shareEmpty": "You have no one to share with yet.",
    "shareAllShared": "Everyone you can share with already has it.",
    "emailSectionLabel": "By email",
    "assigneePlaceholder": "athlete@example.com",
    "invalidEmailFormat": "That doesn't look like a valid email address.",
    "follow": "Follow",
    "unfollow": "Unfollow",
    "followHint": "Follow this program (it shows up in In progress)",
    "publish": "Publish",
    "unpublish": "Back to draft",
    "publishAndFollow": "Publish and follow",
    "publishHint": "Make this program available to follow",
    "chipDraft": "Draft",
    "chipPublished": "Published",
    "chipFollowed": "Following",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "HIST",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Language",
    "languageA11y": "Writing language",
    "languageSwitchQuestion": "Which language are you writing in?",
    "languageDeclareQuestion": "Which language is this program written in?",
    "languageFootnote": "Translations are optional. A program in one language is complete.",
    "languageDeclareFootnote": "Nothing gets translated: this only records the language.",
    "languageAuto": "Machine translation",
    "languageNotYetWritten": "No {{lang}} version yet. The {{original}} text stays where it is.",
    "setBound": "Bound by",
    "boundReps": "Reps",
    "boundTime": "Time",
    "boundOpen": "Open",
    "workSeconds": "Work (s)",
    "restSeconds": "Rest (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Time",
    "prescribeTimeA11y": "Prescribe work and rest in seconds",
    "seconds": "Seconds",
    "amrapNotWithTime": "A {{secs}}s bout can't also be an AMRAP: a plan can't ask how many you'll manage. Drop the + or the time.",
    "workSecondsRequired": "How long?",
    "descriptionAdd": "Add a description",
    "descriptionExpand": "Opens the description for editing",
    "descriptionCollapse": "Collapse the description",
    "undo": "Undo",
    "redo": "Redo",
    "saveStatus": {
      "saving": "Saving…",
      "unsaved": "Not saved",
      "queued": "Offline",
      "saved": "Saved"
    },
    "draftConflict": {
      "title": "The program has changed",
      "body": "It was changed elsewhere after your draft was started. Keep your draft, or use the updated version? Nothing changes until you tap Save.",
      "keepDraft": "Keep my draft",
      "useUpdated": "Use the updated version"
    },
    "savedElsewhere": {
      "body": "It was changed elsewhere after you opened it. Nothing was saved. Keeping your draft replaces that version.",
      "statusNotApplied": "Your status change was not applied."
    },
    "savedStaysOpen": "Saved. The editor stays open.",
    "savedQueuedStaysOpen": "Queued: it goes out when the network is back.",
    "newDraft": {
      "title": "A draft in progress",
      "body": "A draft started on this device on {{when}} was never saved. Resume it, or start over and throw it away?",
      "bodyNoTime": "A draft started on this device was never saved. Resume it, or start over and throw it away?",
      "resume": "Resume",
      "startOver": "Start over"
    },
    "repsRange": "Range",
    "repsRangeMin": "Fewest reps",
    "repsRangeMax": "Most reps",
    "prescribeRangeA11y": "Prescribe a rep range on the sets"
  },
  "me": {
    "targets": {
      "title": "Goals",
      "historyByCoach": "Your coach",
      "errNotFound": "Couldn't find your targets. Go back and retry."
    }
  },
  "coach": {
    "title": "Coach & athletes",
    "subtitle": "Athletes you coach and coaches who coach you. Invitations need both sides to consent before assignments can flow.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Invite an athlete by email",
    "invitePlaceholder": "athlete@example.com",
    "inviteNotePlaceholder": "Note (optional)",
    "inviteSend": "Send invite",
    "inviteSending": "Sending…",
    "inviteSent": "Invite sent. The athlete sees it on their next sign-in.",
    "athletesHeading": "Athletes I coach",
    "coachesHeading": "Coaches who coach me",
    "athletesEmpty": "No athletes yet. Invite one above.",
    "pendingInLabel": "Awaiting your response",
    "pendingOutLabel": "Waiting on them",
    "activeLabel": "Active",
    "accept": "Accept",
    "decline": "Decline",
    "cancel": "Cancel invite",
    "revoke": "Revoke",
    "leave": "Leave coach",
    "busy": "Working…",
    "loading": "Loading edges…",
    "loadFailed": "Could not load. Refresh to retry.",
    "errCode": {
      "invalid_email": "That email looks malformed.",
      "email_not_found": "No verified account with that email.",
      "peer_required": "Provide an email or a sub.",
      "edge_exists": "An edge with this peer already exists.",
      "userpool_not_configured": "Server misconfigured: user pool unavailable.",
      "io_error": "Network or server error. Try again.",
      "not_pending": "This invitation isn't pending any more.",
      "wrong_party": "Only the other side can accept this invite.",
      "missing_claims": "Your session expired. Sign in again.",
      "table_not_configured": "Server misconfigured: table unavailable.",
      "not_found": "This invitation no longer exists."
    },
    "dashboard": {
      "title": "Team overview",
      "unnamedAthlete": "Athlete",
      "empty": "No athletes yet",
      "emptySub": "Invite athletes from Coach & athletes to see them here.",
      "loading": "Loading your team…",
      "loadFailed": "Could not load your team. Refresh to retry.",
      "noProgram": "No program",
      "kpiAssigned": "Athletes",
      "kpiActive": "Active this week",
      "kpiAttention": "Need attention",
      "kpiAdherence": "Avg adherence",
      "kpiSessions": "Sessions this week",
      "kpiNotLoaded": "Not loaded: {{count}}. Counted only in Athletes.",
      "adherence": "adherence",
      "lastNever": "never trained",
      "flagStale": "Not training",
      "flagUnderTarget": "Under target",
      "flagOnTrack": "On track",
      "flagNoProgram": "No program"
    },
    "detail": {
      "back": "Back to team",
      "maxesTitle": "Current MAX",
      "maxesEmpty": "No MAX recorded yet",
      "rhythmSummary": "avg {{avg}}/week over {{weeks}} weeks · last week: {{last}}",
      "effortTitle": "Effort coverage",
      "effortLabel": "sets with a recorded RIR",
      "effortSummary": "{{tagged}} of {{counted}} counted sets, warm-ups included",
      "effortEra": "Effort data starts {{date}} · {{count}} earlier sets aren't counted",
      "effortNone": "No set carries an effort value yet, so the hard-set and target numbers have nothing to rest on.",
      "effortError": "Couldn't load the effort data.",
      "maxesSeeAll": "Show all (+{{count}})",
      "maxesShowFewer": "Show fewer",
      "assignProgram": "Assign program"
    },
    "targets": {
      "eyebrow": "Weekly targets",
      "edit": "Edit targets",
      "degradedHint": "This athlete has no weekly targets yet. Set some to score their week against a goal.",
      "noGrant": "Read-only — the athlete hasn't granted you target edits.",
      "historyTitle": "Change history",
      "historyEmpty": "No changes yet.",
      "historyByYou": "You",
      "historyTruncated": "Showing the most recent 1000 changes.",
      "histGeneric": "Targets updated",
      "histSet": "set to {{value}}",
      "histRemoved": "removed",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Loading…",
      "errLoad": "Couldn't load these targets. Go back and retry.",
      "errStale": "These targets changed while you were editing. Reload and re-apply.",
      "errNoGrant": "The athlete hasn't granted you target edits.",
      "errNotCoach": "You aren't this athlete's coach.",
      "errMultiAssignee": "This program is shared by more than one athlete.",
      "errRetry": "Still loading, try again in a moment.",
      "errNotFound": "This program no longer exists.",
      "errOffline": "Couldn't save. Check your connection and try again."
    },
    "assignPicker": {
      "title": "Assign to {{name}}",
      "cancel": "Cancel",
      "rowA11y": "Assign {{name}}",
      "assignedTitle": "Sent",
      "assignedBody": "Sent to {{name}} — waiting for them to accept.",
      "alreadyTitle": "Already assigned",
      "alreadyBody": "{{name}} already has this.",
      "errAssign": "Could not assign. Try again."
    },
    "sessions": {
      "title": "Sessions",
      "setsTitle": "Sets",
      "noSets": "No sets logged in this session.",
      "setA11y": "Set {{n}}: {{summary}}",
      "loadFailed": "Couldn't load the sessions.",
      "unavailable": "Couldn't open this session. Go back and try again."
    }
  },
  "plans": {
    "assign": "Assign",
    "title": "Plans",
    "help": "Draft a workout for yourself. Targets can be absolute kg or a percentage of your MAX, resolved to kg when you start the plan.",
    "loading": "Loading plans…",
    "empty": "No plans yet. Add one to draft a session in advance.",
    "todayPill": "Today",
    "add": "Add a plan",
    "edit": "Edit",
    "start": "Start",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Plan saved.",
    "savedEdit": "Plan updated.",
    "deleted": "Plan deleted.",
    "delete": "Delete",
    "deleting": "Deleting…",
    "deleteConfirm": "Delete this plan?",
    "creatingTitle": "New plan",
    "editingTitle": "Edit plan",
    "name": "Name",
    "namePlaceholder": "e.g. Squat day",
    "scheduledFor": "Scheduled for (optional)",
    "pickDate": "Pick a date",
    "pickDateHint": "Opens the date picker",
    "clearDate": "Clear date",
    "noDate": "Not set",
    "notes": "Notes (optional)",
    "rpeEnabledLabel": "Show RPE column in the Logger",
    "rpeEnabledHelp": "When on, sessions started from this plan open with the RPE column visible. Athletes can still toggle it per session.",
    "exercise": "Exercise",
    "exercisePlaceholder": "Pick an exercise",
    "exerciseN": "Exercise {{n}}",
    "removeExercise": "Remove exercise",
    "addExercise": "Add another exercise",
    "setsLegend": "Sets",
    "targetReps": "Reps",
    "targetWeight": "Weight",
    "targetKind": "Unit",
    "targetRpe": "RPE",
    "noMaxYet": "no MAX set",
    "addSet": "Add set",
    "removeSet": "Remove set",
    "statusDraft": "Draft",
    "statusScheduled": "Scheduled",
    "statusCompleted": "Completed",
    "statusSkipped": "Skipped",
    "errNotSignedIn": "You must be signed in.",
    "errNameRequired": "Give the plan a name.",
    "errPickExercise": "Pick an exercise from the catalog.",
    "errNoSets": "Add at least one valid set.",
    "errGroupKindMixed": "Two entries share a group id but disagree on whether it's a superset or a circuit. Pick one and re-save.",
    "errCode": {
      "invalid_email": "That email looks malformed.",
      "email_not_found": "No account found with that email.",
      "too_many_assignees": "Up to 20 people per program."
    },
    "assignTo": "Assign to athletes",
    "assignToHelp": "Assigning is an offer: it reaches their library only if they accept, and what they accepted stays theirs if you remove them. Needs an active coach edge with you first.",
    "assignSelf": "You (creator)",
    "addAssignee": "Add",
    "removeAssignee": "Remove",
    "removeAssigneeConfirm": "Remove access?",
    "removeAssigneeHint": "They'll lose this from their library. Tap again to remove.",
    "pendingAssigneeCaption": "Pending",
    "rosterSectionLabel": "From your roster",
    "rosterEmpty": "No athletes in your roster yet.",
    "rosterAllAssigned": "Everyone in your roster is already assigned.",
    "shareTo": "Share with",
    "shareToHelp": "Sharing sends an offer: it reaches their library only if they accept, and what they accepted stays theirs if you remove them.",
    "shareSectionLabel": "People you can share with",
    "shareEmpty": "You have no one to share with yet.",
    "shareAllShared": "Everyone you can share with already has it.",
    "emailSectionLabel": "By email",
    "assigneePlaceholder": "name@example.com",
    "invalidEmailFormat": "That doesn't look like a valid email address.",
    "exerciseNew": "Pick an exercise",
    "setIndex": "Set {{n}}",
    "cardMenu": "Card menu",
    "menuGroup": "Group",
    "menuMoveUp": "Move up",
    "menuMoveDown": "Move down",
    "groupNone": "No group",
    "groupJoinExisting": "Join existing",
    "groupCreate": "Create",
    "groupNewSuperset": "New superset",
    "groupNewCircuit": "New circuit",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuit {{letter}}",
    "details": "Details",
    "exercisesLabel": "Exercises",
    "editorEmpty": "No exercises yet. Add one to start building this plan.",
    "selectExercisePrompt": "Select an exercise to edit its sets.",
    "addExerciseCta": "Add exercise",
    "removeExerciseConfirm": "Remove this exercise?",
    "removeExerciseHint": "Tap once to confirm, then tap again to remove.",
    "collapseExercise": "Collapse exercise",
    "supersetTag": "SUPERSET",
    "exerciseNoteLabel": "Exercise note (optional)"
  },
  "templates": {
    "show": "Browse starter templates",
    "hide": "Hide templates",
    "help": "Common starter plans and programs. Clone one into your account — you can edit or delete the copy without touching the template.",
    "loading": "Loading templates…",
    "empty": "No templates available right now.",
    "errLoad": "Could not load templates.",
    "clone": "Clone to my plans",
    "cloning": "Cloning…",
    "cloned": "Cloned \"{{name}}\".",
    "alreadyCloned": "Already cloned",
    "difficultyBeginner": "Beginner",
    "difficultyIntermediate": "Intermediate",
    "difficultyAdvanced": "Advanced",
    "planMeta": "{{n}} exercise(s)",
    "programMeta": "{{weeks}}-week cycle · {{sessions}}× / week"
  },
  "maxes": {
    "title": "Maxes",
    "countLabel_one": "{{count}} set",
    "countLabel_other": "{{count}} set",
    "help": "MAX is what you can hit today, set by you. Programs use it as the percentage base. The estimated 1RM in the Progress section is for reference only.",
    "loading": "Loading maxes…",
    "empty": "No maxes set yet. Add one to drive percentage-based programming.",
    "add": "Add a max",
    "edit": "Edit",
    "delete": "Delete",
    "deleteAction": "Delete max",
    "deleting": "Deleting…",
    "deleted": "Max deleted.",
    "deleteConfirm": "Delete the MAX for {{name}}? The history is removed too. The next seed-from-history pass can repopulate it from your workouts.",
    "exercise": "Exercise",
    "exercisePlaceholder": "Pick an exercise",
    "value": "Value",
    "source": "Source",
    "sourceManual": "Set manually",
    "sourceTested": "Tested in the gym",
    "sourceDerived": "Derived from a logged set",
    "sourceCalculated": "Seeded from history",
    "sourceImported": "Imported",
    "notes": "Notes (optional)",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Max saved.",
    "cancel": "Cancel",
    "errPickExercise": "Pick an exercise.",
    "errInvalidValue": "Enter a value between 0 and 2000.",
    "seed": {
      "start": "Suggest from history",
      "loading": "Reading your workout history…",
      "reviewIntro": "{{count}} exercises have a credible top set in your history. Pick the ones to seed as MAX. Exercises that already have a MAX are skipped.",
      "selectAll": "Select all",
      "selectNone": "Select none",
      "fromSet": "from {{weight}} × {{reps}}",
      "cancel": "Cancel",
      "apply": "Seed {{count}} maxes",
      "applying": "Saving: {{done}} / {{total}}",
      "applied": "Seeded {{count}} maxes from history.",
      "noneApplicable": "Nothing to seed. Either every exercise already has a MAX, or no weighted history was found.",
      "close": "Close"
    }
  },
  "progress": {
    "coverageTitle": "Muscle coverage",
    "coverageSeeAll": "See all muscles (+{{count}})",
    "coverageShowFewer": "Show fewer",
    "coverageCompact": {
      "doneOfExpected": "{{done}} / {{expected}} by today",
      "doneOfExpectedA11y_one": "{{done}} of {{expected}} set by today",
      "doneOfExpectedA11y_other": "{{done}} of {{expected}} sets by today",
      "behind": "{{n}} behind",
      "onPace": "on pace",
      "titleBehind_one": "{{count}} set behind the pace",
      "titleBehind_other": "{{count}} sets behind the pace",
      "titleOnPace": "On pace",
      "subtitle": "hard sets by today vs the band's pace"
    },
    "period": {
      "days": "{{days}} d",
      "painDays": "7 / {{days}} d"
    },
    "title": "Progress",
    "show": "Show",
    "hide": "Hide",
    "help": "MAX is the value you set yourself; estimated 1RM uses Epley as a reference. Volume is the sum of weight times reps for the session.",
    "e1rm": "Estimated 1RM",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "estimated 1RM in dashed",
    "volume": "Volume",
    "sessions": "{{n}} sessions",
    "prFound": "Personal record at {{weight}}.",
    "prUpdating": "Updating…",
    "viewByExercise": "By exercise",
    "viewByTag": "By tag",
    "noTags": "No tagged sessions yet. Tag exercises in the catalog to see aggregate volume here.",
    "totalVolume": "Total {{weight}}",
    "recordsScope": "Records",
    "recordsAllTime": "All time",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Filter exercises",
    "filterCount": "{{visible}} of {{total}}",
    "filterNoMatch": "No exercise matches the filter.",
    "coverageNoData": "Nothing to score yet — log a session, or set a weekly target.",
    "volumeLandmark": {
      "source": {
        "rp": "Renaissance Periodization"
      },
      "citation": {
        "rp": "Published practice landmarks. Individual variance is large — your own data narrows this band."
      },
      "zone": {
        "belowMev": "below MEV",
        "mevMav": "MEV–MAV",
        "mavMrv": "MAV–MRV",
        "aboveMrv": "above MRV",
        "noBand": "no published band"
      },
      "yourTarget": "your target {{v}}",
      "athleteTarget": "target {{v}}",
      "sets_one": "{{n}} set",
      "sets_other": "{{n}} sets"
    },
    "chartGapShort": "+{{count}}d",
    "chartGapLong_one": "{{count}} day since the previous point",
    "chartGapLong_other": "{{count}} days since the previous point",
    "chartMorePoints_one": "+{{count}} more point",
    "chartMorePoints_other": "+{{count}} more points",
    "chartWindowA11y": "{{from}} to {{to}}",
    "chartSummaryA11y": "{{range}}, latest {{last}}, {{window}}",
    "chartTapHint": "Tap a point to read its value",
    "chartCapped": "Only the most recent data is shown. Older data is not in this chart.",
    "muscleState": {
      "thin": "Too little history for a pace: {{n}} of {{needed}} sessions",
      "none": "No hard sets logged yet",
      "a11yOver": "recent load {{pct}}% over the 28-day pace",
      "a11yUnder": "recent load {{pct}}% under the 28-day pace",
      "a11yLevel": "recent load level with the 28-day pace"
    },
    "gapProposal": {
      "toggle": "Close the gap",
      "toMev_one": "<num>{{n}}</num> set/wk to MEV",
      "toMev_other": "<num>{{n}}</num> sets/wk to MEV",
      "basis": "MEV {{mev}} − avg {{avg}}/wk = {{gap}}/wk",
      "eachAlone": "Any one of these closes it on its own:",
      "alsoWorks": "also works {{muscles}}",
      "atPlace": "At {{place}}, without what you marked missing there.",
      "noPlace": "Whole catalog: no default place set.",
      "wholeCatalog": "Whole catalog: where the athlete trains isn't shared with coaches.",
      "noneAtPlace": "Nothing left at {{place}}: every exercise for this muscle is marked missing there.",
      "noneInCatalog": "No exercise in the catalog trains this muscle.",
      "shortHistory_one": "Sizing the gap needs 4 full weeks of history: {{n}} so far.",
      "shortHistory_other": "Sizing the gap needs 4 full weeks of history: {{n}} so far.",
      "a11yToggle": "{{muscle}}: close the gap, {{gap}} sets per week to MEV",
      "buildToday": "Build today's session from these gaps"
    }
  },
  "cohort": {
    "compare": "Compare to cohort (anonymous)",
    "hide": "Hide cohort",
    "loading": "Loading cohort…",
    "empty": "Not enough contributors yet to show a comparison. The minimum is ten people in the same age group.",
    "contributors": "Based on {{n}} anonymous contributors with their age range set.",
    "yourGroup": "your group"
  },
  "catalog": {
    "title": "Exercise catalog",
    "empty": "No exercises yet.",
    "region": "Region",
    "region_lower": "Lower body",
    "region_posterior": "Posterior chain",
    "region_chest": "Chest",
    "region_back": "Back",
    "region_shoulders": "Shoulders",
    "region_arms": "Arms",
    "region_core": "Core",
    "region_cardio": "Cardio",
    "region_other": "Other",
    "pattern": "Pattern",
    "pattern_squat": "Squat",
    "pattern_hinge": "Hinge",
    "pattern_horizontal-push": "Horizontal push",
    "pattern_vertical-push": "Vertical push",
    "pattern_horizontal-pull": "Horizontal pull",
    "pattern_vertical-pull": "Vertical pull",
    "pattern_lunge": "Lunge",
    "pattern_carry": "Carry",
    "pattern_core": "Core",
    "pattern_isolation": "Isolation",
    "pattern_mobility": "Mobility",
    "pattern_cardio": "Cardio",
    "pattern_other": "Other",
    "equipment": "Equipment",
    "equipment_barbell": "Barbell",
    "equipment_dumbbell": "Dumbbell",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Cable",
    "equipment_machine": "Machine",
    "equipment_bodyweight": "Bodyweight",
    "equipment_band": "Band",
    "equipment_other": "Other",
    "tags": "Tags",
    "equipment_treadmill": "Treadmill",
    "equipment_exercise-bike": "Exercise bike",
    "equipment_elliptical": "Elliptical",
    "equipment_rower": "Rower",
    "equipment_stair-climber": "Stair climber",
    "equipment_jump-rope": "Jump rope",
    "equipment_battle-ropes": "Battle ropes",
    "equipment_sled": "Sled",
    "deletedExercise": "Deleted exercise"
  },
  "swap": {
    "title": "Swap exercise",
    "currentLabel": "Current",
    "searchPlaceholder": "Search the catalog…",
    "showAll": "Show all exercises",
    "noMatches": "No exercises match your search.",
    "noSuggestions": "No tagged similars found. Tick \"Show all\" to browse the full catalog.",
    "close": "Close",
    "reasonTags": "Tag overlap ×{{count}}",
    "reasonPrimary": "Muscle overlap ×{{count}}",
    "reasonDifferentEquipment": "Different gear",
    "suggestedSection": "Suggested",
    "allSection": "All exercises",
    "whichMachine": "Which machine?",
    "defaultMachine": "Default machine",
    "machineLabel": "Machine {{letter}}",
    "setMachine": "Set machine",
    "machineChoices": "Machines known: {{count}}",
    "newMachine": "New machine",
    "bandSession": "Session",
    "bandCurrentExercise": "This exercise",
    "bandOtherExercises": "Switch to another exercise",
    "equipmentKey": "Gear",
    "currentConsequence": "Sets you already logged stay: only the gear they are marked on changes.",
    "unavailableTitle": "Not here?",
    "unavailableBody": "Tick the {{exercise}} gear that is not at {{place}}. Only what you tick is recorded.",
    "unavailableConfirm": "Save",
    "unavailableOpen": "Gear not available here",
    "unavailableOpenHint": "Asks which of this exercise's gear is missing.",
    "unavailableBadge": "Not here",
    "unavailableRestore": "Available here again",
    "unavailableErrorTitle": "Not saved",
    "unavailableErrorBody": "That gear is still marked as available here.",
    "unavailableConfirmHint": "Tick at least one to save.",
    "pinDefaultMachine": "Always use the default machine here",
    "pinMachine": "Always use {{machine}} here",
    "pinHint": "Stops asking which machine, at this gym, for this exercise.",
    "pinErrorTitle": "Not saved",
    "pinErrorBody": "The default machine here is unchanged.",
    "unpinDefaultMachine": "Stop always using the default machine here",
    "unpinMachine": "Stop always using {{machine}} here",
    "pinnedFootnoteDefault": "Always uses the default machine here.",
    "pinnedFootnoteMachine": "Always uses {{machine}} here.",
    "unpinHint": "Goes back to asking which machine, at this gym, for this exercise."
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Chest",
        "biceps": "Biceps",
        "triceps": "Triceps",
        "forearm": "Forearms",
        "front-deltoids": "Shoulders",
        "back-deltoids": "Rear delts",
        "trapezius": "Traps",
        "upper-back": "Back",
        "lower-back": "Lower back",
        "abs": "Core",
        "obliques": "Core",
        "quadriceps": "Quads",
        "hamstring": "Hamstrings",
        "gluteal": "Glutes",
        "adductors": "Adductors",
        "abductors": "Abductors",
        "calves": "Calves",
        "tibialis": "Tibialis",
        "neck": "Neck",
        "head": "Head"
      }
    },
    "tabs": {
      "workouts": "Workouts",
      "plan": "Home",
      "progress": "Progress",
      "catalog": "Catalog",
      "profile": "Profile",
      "settings": "Settings",
      "inbox": "Inbox",
      "athletes": "Athletes",
      "library": "Library",
      "me": "Me"
    },
    "me": {
      "sectionTraining": "Training",
      "navTargets": "Goals",
      "navTargetsSub": "Your weekly training targets"
    },
    "settings": {
      "title": "Settings",
      "exercisesSection": "Exercises",
      "navExercisesSub": "MAXes, catalog, effort scale",
      "navCatalog": "Exercise catalog",
      "selectPrompt": "Select a setting to open it.",
      "navCatalogSub": "Browse the exercise library",
      "navEffort": "Effort settings",
      "navEffortSub": "RIR / RPE scale + legend",
      "navLicenses": "Open source licenses",
      "navLicensesSub": "Libraries that power the app",
      "sectionAccount": "Account",
      "sectionTraining": "Training",
      "sectionBody": "Body",
      "sectionPrefs": "Preferences",
      "sectionCoach": "Coach",
      "sectionAbout": "About",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Sync workouts & health data from your device"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "$t(brand.product)",
      "pillLabel": "Calorie sources",
      "projectionNote": "Includes the set you're about to do: a projection of the whole session, not work you've already logged.",
      "selected": "selected"
    },
    "hc": {
      "preferences": "Preferences",
      "caloriesWins": "Health Connect wins for calories",
      "caloriesWinsHelp": "When both exist, show the calories measured through Health Connect instead of $t(brand.product)'s own estimate. Off = prefer the estimate. With no Health Connect value, the estimate is always used.",
      "title": "Health Connect",
      "intro": "Import your watch & phone activity into $t(brand.product). Walks, hikes and rides become workouts; heart rate and calories enrich the sessions you log. Off until you connect.",
      "checking": "Checking…",
      "unavailable": "Health Connect is not available on this device.",
      "updateRequired": "Update the Health Connect app to continue.",
      "notConnected": "Not connected.",
      "connect": "Connect Health Connect",
      "connectHelp": "You choose which data $t(brand.product) may read. Change it any time in Health Connect.",
      "connected": "Connected",
      "reads": "Reading workouts, heart rate and calories.",
      "syncNow": "Sync now",
      "neverSynced": "Not synced yet.",
      "lastSyncedAt": "Last sync: {{when}}",
      "syncDelayNote": "New activity can take a few minutes to reach Health Connect from your device — a recent walk or ride may only appear on a later sync. That delay is normal.",
      "syncFullHistory": "Sync full history",
      "syncingFullHistory": "Syncing full history",
      "syncFullHistoryHelp": "Re-check your whole history and fill any gaps in Health Connect. Use this if a past correction is missing there. Safe to repeat.",
      "resultSummary": "{{imported}} imported · {{enriched}} enriched · {{skipped}} skipped",
      "error": "Something went wrong. Please try again.",
      "grantRefused": "Your account did not record this consent, so $t(brand.product) will not read Health Connect. Try connecting again later.",
      "revokeRefused": "Health Connect is disconnected on this phone, but your account did not record the withdrawal and still shows your consent. Try again later.",
      "revokedElsewhere": "You withdrew your consent on another device, so Health Connect is disconnected on this phone.",
      "manageInHc": "Manage in Health Connect",
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect Health Connect?",
      "disconnectBody": "$t(brand.product) will stop reading your Health Connect data. Workouts already imported stay in your history.",
      "logoA11y": "Health Connect",
      "privacyTitle": "Your data",
      "privacyBody": "$t(brand.product) reads only what you allow in Health Connect, and only on this phone after you connect. It is stored in your private $t(brand.product) account, never shared or sold. Disconnect any time to stop.",
      "explainerTitle": "What $t(brand.product) reads, and why",
      "explainerIntro": "Android asks you next. You can allow all of it, part of it or none, and change it any time in Health Connect.",
      "explainerContinue": "Continue to Android",
      "explainerCancel": "Not now",
      "consentGiven": "Consent given on {{when}}.",
      "consentWithdrawn": "Consent given on {{given}}, withdrawn on {{withdrawn}}.",
      "consentWithdrawnOnly": "Consent withdrawn on {{withdrawn}}.",
      "consentBeforeRecord": "Consent given before $t(brand.product) recorded its date.",
      "consentCategories": "What you allowed",
      "consentRecordNote": "This record belongs to your account and keeps each consent and withdrawal with its date. Android gives the permission on each phone separately.",
      "explainerMore": "More below, scroll to read it all.",
      "deviceAllowed": "On this phone: allowed by Android.",
      "deviceNotAllowed": "On this phone: not allowed by Android.",
      "driftDeviceOff": "Your account holds your consent, but Android no longer allows it on this phone. Allow it again to sync here.",
      "driftNoRecord": "Android allows it on this phone, but your account holds no current consent. Review what $t(brand.product) reads, then confirm in Android's prompt. Your account records it with today's date.",
      "driftUndated": "Your consent has no date yet. Review what $t(brand.product) reads, then confirm in Android's prompt: your account records it with today's date.",
      "allowOnPhone": "Allow on this phone",
      "confirmConsent": "Review and confirm",
      "permOther": "Other permission",
      "perm": {
        "readExerciseSession": {
          "name": "Exercise sessions",
          "use": "A walk, run or ride recorded by your watch or phone appears in your timeline as a workout."
        },
        "readHeartRate": {
          "name": "Heart rate",
          "use": "Average and peak heart rate show on each workout, and feed the calorie estimate."
        },
        "readActiveCaloriesBurned": {
          "name": "Active calories",
          "use": "The measured calories show on each workout, next to the estimate."
        },
        "readDistance": {
          "name": "Distance",
          "use": "Fills in the distance on the cardio sets of a workout from your watch or phone."
        },
        "readWeight": {
          "name": "Weight",
          "use": "Joins your bodyweight history and chart in Body."
        },
        "readBodyFat": {
          "name": "Body fat",
          "use": "Shows on the body composition chart in Body."
        },
        "readLeanBodyMass": {
          "name": "Lean body mass",
          "use": "Shows on the body composition chart in Body."
        },
        "readNutrition": {
          "name": "Nutrition",
          "use": "Today's carbohydrates show on the Metabolic card, next to your glucose."
        },
        "readBloodGlucose": {
          "name": "Blood glucose",
          "use": "Your readings show on the Metabolic card, as a curve and the latest value."
        },
        "writeBloodGlucose": {
          "name": "Write blood glucose",
          "use": "A glucose reading you enter in $t(brand.product) is saved to Health Connect too."
        },
        "writeWeight": {
          "name": "Write weight",
          "use": "A weigh-in you enter in $t(brand.product) is saved to Health Connect too."
        }
      },
      "bodyResult": "{{imported}} body imported · {{skipped}} skipped",
      "bodyNotGranted": "Body data not granted yet. Tap Grant body data.",
      "readsFull": "Reading workouts, heart rate and calories, weight and body composition, glucose and nutrition. Writing glucose and weight back to Health Connect.",
      "backfillTitle": "Import history from May?",
      "backfillBody": "Scans your Health Connect history back to May and imports anything missing. Safe to run more than once: already-imported items are skipped.",
      "backfillNow": "Import history",
      "grantExtra": "Grant health data",
      "extraGrantBody": "Also import weight, body composition, glucose and nutrition.",
      "metabolicResult": "{{glucose}} glucose · {{nutrition}} nutrition imported",
      "metabolicNotGranted": "Glucose and nutrition not granted yet.",
      "writeGlucoseGrantBody": "Allow $t(brand.product) to write glucose to Health Connect.",
      "grantWrite": "Allow write",
      "syncGlucoseToHc": "Write glucose to Health Connect"
    },
    "metabolic": {
      "title": "Metabolic",
      "loading": "Loading…",
      "empty": "Connect Health Connect and sync to see glucose and nutrition here.",
      "glucoseEmpty": "No glucose readings",
      "mgdl": "mg/dL",
      "targetBand": "Typical target range {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Carbs today",
      "grams": "g",
      "glucoseTitle": "Glucose",
      "glucoseCurrent": "Latest: {{value}} {{unit}}",
      "glucoseNone": "Log a reading to track your glucose.",
      "help": "Your glucose from Health Connect, with recent carbs below it. Tap a point on the chart to read its value and time."
    },
    "exercisesScreen": {
      "back": "Back"
    },
    "body": {
      "back": "Back",
      "title": "Body",
      "navTitle": "Body",
      "navSub": "Sex, age, figure",
      "navPainMapSub": "Mark where it hurts",
      "trendsWebHint": "Body-composition charts are on the mobile app.",
      "sexLabel": "Sex",
      "sexHelp": "Used only for the body-fat estimate. The body-map figure is a separate choice below.",
      "sex_male": "Male",
      "sex_female": "Female",
      "measurementsTitle": "Measurements",
      "measurementsSub": "Weight, circumferences, body-fat estimate",
      "measureTitle": "NEW MEASUREMENT",
      "weight": "Weight",
      "field_heightCm": "Height",
      "field_neckCm": "Neck",
      "field_chestCm": "Chest",
      "field_waistCm": "Waist",
      "field_hipsCm": "Hips",
      "field_bicepsLCm": "Biceps (L)",
      "field_bicepsRCm": "Biceps (R)",
      "field_forearmsLCm": "Forearm (L)",
      "field_forearmsRCm": "Forearm (R)",
      "field_thighsLCm": "Thigh (L)",
      "field_thighsRCm": "Thigh (R)",
      "field_calvesLCm": "Calf (L)",
      "field_calvesRCm": "Calf (R)",
      "measureSave": "Save entered values",
      "measureHelpC": "Fill only what you measured. Empty fields aren't saved.",
      "useLastA11y": "Use last value {{value}}",
      "saveFailedTitle": "Couldn't save",
      "saveFailedBody": "Your measurement wasn't saved. Your values are kept — tap Save to retry.",
      "editTitle": "EDIT — {{date}}",
      "saveChanges": "Save changes",
      "editCancelA11y": "Cancel edit",
      "editRowA11y": "Edit measurement {{date}}",
      "editHelp": "Change a value, or clear it to remove it from history.",
      "trendsLabel": "TRENDS",
      "trendsHint": "select metrics",
      "trendsExpandA11y": "Show all metrics",
      "trendsCollapseA11y": "Collapse metrics",
      "trendsPick": "Select a measurement above to see its trend.",
      "metricComposition": "Composition",
      "metricBodyFat": "Body fat",
      "metricLeanMass": "Lean mass",
      "loadError": "Couldn't load measurements — check your connection.",
      "navyTitle": "BODY COMPOSITION (NAVY)",
      "navyNeedsEntry": "Save a measurement below to estimate body fat.",
      "navyNeedsSex": "Set your sex above to estimate body fat.",
      "navyNeedsInputs": "Add height, neck, waist (and hips, for the female formula) to estimate body fat.",
      "navyBodyFat": "Body fat ≈ {{pct}}%",
      "navyLeanMass": "Lean mass ≈ {{mass}}",
      "navyDisclaimer": "US Navy estimate (~±3.5%). Watch the trend, not the single number.",
      "historyEmpty": "No measurements yet. Save one above to start tracking.",
      "historyTitle": "HISTORY",
      "trendWeight": "WEIGHT TREND",
      "trendBodyFat": "BODY-FAT TREND",
      "deleteTitle": "Delete measurement?",
      "deleteEmptyTitle": "Remove this measurement?",
      "deleteEmptyBody": "All its values are cleared, so the entry will be deleted.",
      "deleteCancel": "Cancel",
      "deleteConfirm": "Delete",
      "ageLabel": "Age",
      "ageHelp": "Optional. Tap again to clear.",
      "dualCurveLegend": "Solid: estimate · Dashed: Health Connect",
      "estimateSeriesName": "Estimate",
      "bodyFatProvenance": "Body fat is calculated from waist and neck.",
      "bodyFatProvenanceWithHips": "Body fat is calculated from waist, neck and hips.",
      "trendsHelp": "One chart for each metric you select above. Tap a point on a chart to read its value and date."
    },
    "effortSettings": {
      "back": "Back",
      "title": "Effort",
      "scaleLabel": "Effort scale",
      "scaleHelp": "Which scale the Logger speaks. RIR = reps left in the tank; RPE = perceived exertion. RPE = 10 − RIR, so they are the same effort on two scales."
    },
    "plan": {
      "currentBlockError": "Couldn't set the current block. Please try again.",
      "currentBlockOn": "Current block — tap to unpin",
      "currentBlockOff": "Set as current block",
      "currentBlockHint": "Pins this program's weekly targets to the Home meter",
      "title": "Plan",
      "start": "Start",
      "starting": "Starting…",
      "programWeekSession": "Week {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Last: W{{week}} · {{session}}",
      "programNextHeader": "Next up",
      "programStartCta": "▶ Start {{session}}",
      "programChangeLink": "Change week or session ›",
      "carouselPosition": "Program {{n}} of {{total}}",
      "carouselPrev": "Previous program",
      "carouselNext": "Next program",
      "programWeekLabel": "Week",
      "singleCycle": "Single cycle, same every week",
      "programSessionLabel": "Session",
      "programWeekShort": "W{{n}}",
      "programDayShort": "D{{n}}",
      "sessionN": "Session {{n}}",
      "sessionNShort": "S{{n}}",
      "programConfirm": "Start W{{week}} · {{session}}",
      "cancel": "Cancel",
      "newWorkout": "New workout",
      "programsHint": "Multi-week cycles that auto-advance as you log sessions.",
      "planDeleteTitle": "Delete plan?",
      "programDeleteTitle": "Delete program?",
      "programStatusError": "Could not update the program. Try again.",
      "view": "View",
      "hide": "Hide",
      "programUnfollowHint": "Stop following this program (it stays in My programs)",
      "programNextInline": "Next: W{{week}} · {{session}}",
      "programStartA11y": "Start {{session}}",
      "startPlanA11y": "Start {{name}}"
    },
    "preview": {
      "muscles": "Muscles",
      "noSets": "No sets prescribed",
      "alternates": "Alternates: {{names}}",
      "gridTitle": "Intensity · day × week",
      "gridHint": "Tap a day to see its lifts.",
      "matrixTitle": "Intensity · by set",
      "matrixHint": "Tap an exercise to see its sets.",
      "restDay": "Rest / light",
      "intensity": {
        "work": "work",
        "moderate": "moderate",
        "heavy": "heavy",
        "max": "Max",
        "free": "free"
      }
    },
    "catalog": {
      "title": "Catalog",
      "search": "Search exercises",
      "empty": "No exercises match.",
      "back": "Back",
      "notFound": "Exercise not found.",
      "metaPrimaryMuscle": "Primary muscle",
      "metaPattern": "Pattern",
      "metaEquipment": "Equipment",
      "metaP1RM": "Programmable",
      "metaP1RMYes": "Yes",
      "metaP1RMNo": "No",
      "metaDefaultBar": "Default bar",
      "metaBarLoading": "Loading",
      "metaBarLoadingSingleSide": "One side only",
      "aliasesLabel": "Also known as",
      "tagsLabel": "Tags",
      "historyLabel": "Recent sessions",
      "historyEmpty": "No past sessions for this exercise.",
      "historyError": "Could not load history.",
      "historyBodyweight": "{{reps}} reps BW",
      "recordsLabel": "Records",
      "recordsEmpty": "No records yet.",
      "selectPrompt": "Select an exercise to see its details.",
      "recordsError": "Could not load records.",
      "refreshing": "Updating…"
    },
    "maxes": {
      "title": "MAXes",
      "back": "Back",
      "search": "Search exercises",
      "empty": "No exercises match.",
      "editCancel": "Cancel",
      "editSave": "Save",
      "errInvalid": "Enter a valid weight.",
      "clearAction": "Remove MAX",
      "clearTitle": "Remove this MAX?",
      "clearBody": "The current value and history are kept on the server but the MAX will read as unset.",
      "clearCancel": "Cancel",
      "clearConfirm": "Remove",
      "selectPrompt": "Select an exercise to set its MAX.",
      "unitChipLabel": "Weight unit: {{unit}}",
      "unitKg": "kilograms",
      "unitLb": "pounds",
      "unitChipHint": "Switches the unit and converts the value",
      "notSet": "Not set",
      "loadFailed": "Couldn't load"
    },
    "login": {
      "title": "$t(brand.product)",
      "subtitle": "Sign in to your account",
      "submit": "Sign in"
    },
    "workouts": {
      "title": "Workouts",
      "empty": "No workouts logged yet.",
      "fallbackName": "Workout",
      "endOfList_one": "{{count}} session — end of list.",
      "endOfList_other": "{{count}} sessions — end of list.",
      "newButton": "New",
      "queueDismissCancel": "Cancel",
      "editUnsupportedTitle": "Edit not yet supported on mobile",
      "editUnsupportedBody": "This workout contains exercise types (P1RM, loaded carry) the mobile logger can't edit yet. Open it on the web app instead.",
      "editUnsupportedAck": "OK",
      "repeat": "Repeat workout",
      "resumePillAction": "Resume",
      "resumePillFallback": "Workout in progress",
      "cancel": "Cancel",
      "loadOlder": "Load older months",
      "selectPrompt": "Select a workout to see its summary.",
      "loadError": "Could not load this session.",
      "importedBadge": "Imported"
    },
    "outboxDetail": {
      "errCorrectionTooBig": "Too many sets changed at once for the server.",
      "errCorrectionBusy": "The server was busy with this workout.",
      "errCorrectionConflict": "This workout changed on another device.",
      "errCorrectionStale": "This workout was saved again after this correction began.",
      "errCorrectionTimes": "The workout ends before it starts.",
      "errCorrectionGone": "This workout was deleted on another device.",
      "errSetsUnknownExercise": "The server didn't recognize an exercise of this workout.",
      "errSetsInvalidTag": "The server didn't accept a tag on a set of this workout.",
      "errSetsInvalid": "The server found some sets of this workout invalid.",
      "errSetsNotSaved": "Not all the sets reached the server.",
      "close": "Close",
      "empty": "Nothing left to send.",
      "statusQueued": "Queued",
      "statusSending": "Sending",
      "statusFailed4xx": "Server rejected",
      "statusPermanentFail": "Gave up",
      "attempts_one": "{{count}} attempt",
      "attempts_other": "{{count}} attempts",
      "dismissOne": "Dismiss",
      "dismissOneTitle": "Dismiss this workout?",
      "dismissOneBody": "The workout from {{date}} will be removed without saving.",
      "dismissCancel": "Cancel",
      "dismissConfirm": "Dismiss",
      "retryAll": "Retry all",
      "queueWorkout": "Workout",
      "queueWorkoutNote": "Workout note",
      "queueMeasurement": "Measurement",
      "queueMax": "Max",
      "queueProfile": "Profile",
      "queueHealth": "Health data",
      "queueMetabolic": "Metabolic data",
      "queueRequest": "Change",
      "stuckTitle": "Writes that didn't go through"
    },
    "progress": {
      "title": "Progress",
      "windowAll": "Recent sessions",
      "window30d": "Last 30 days",
      "window7d": "Last 7 days",
      "lastSession": "Last session",
      "frequencyTitle": "Weekly frequency",
      "frequencyHelp": "Sessions per week, the current one on the right.",
      "rhythmThisWeek": "This week so far: {{n}}",
      "rhythmAverageWeeks_one": "Average over {{count}} full week: {{avg}}",
      "rhythmAverageWeeks_other": "Average over {{count}} full weeks: {{avg}}",
      "weekBars": {
        "thisWeek": "this week so far",
        "weekOf": "week of {{date}}",
        "sessions": "Sessions"
      },
      "weekStreakCurrent": "Current streak",
      "weekStreakBest": "Best streak",
      "weekStreakWeeks_one": "week",
      "weekStreakWeeks_other": "weeks",
      "weekStreakStatA11y_one": "{{label}}: {{count}} week",
      "weekStreakStatA11y_other": "{{label}}: {{count}} weeks",
      "weekStreakWithThisWeek_one": "{{count}} week in a row with at least one session, this week included.",
      "weekStreakWithThisWeek_other": "{{count}} weeks in a row with at least one session, this week included.",
      "weekStreakUpToLastWeek_one": "{{count}} week in a row with at least one session, up to last week. This week is still open.",
      "weekStreakUpToLastWeek_other": "{{count}} weeks in a row with at least one session, up to last week. This week is still open.",
      "weekStreakNone": "No session last week and none yet this week. This week is still open.",
      "weekStreakEmpty": "No sessions yet.",
      "weekStreakSessionsHelp": "Sessions in each week. The outlined column is this week: it already counts.",
      "recordsTitle": "Records",
      "recordsHelp": "Best per-rep records per exercise. Latest update first.",
      "recordsEmpty": "No records yet. Log a few weighted sets to populate.",
      "recordsAllTime": "All-time",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Filter by exercise",
      "recordsNoMatch": "No exercise matches the filter.",
      "tagVolumeTitle": "Volume by tag",
      "tagVolumeWeeksHelp": "One muscle's training volume per week. Pick the muscle.",
      "chartE1rm": "Estimated 1RM",
      "chartVolume": "Volume",
      "chartLoadFailed": "Could not load chart data.",
      "chartEmpty": "No weighted sets in the recent window.",
      "viewByExercise": "By exercise",
      "viewByTag": "By tag",
      "noTags": "No volume on any muscle in the last weeks.",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "with e1RM overlay",
      "prFound": "PR found: {{weight}}",
      "prUpdating": "Updating…",
      "painSeverity": {
        "red": "red",
        "yellow": "yellow",
        "green": "green"
      },
      "balance": {
        "title": "Movement balance",
        "help": "Sets and volume per movement pattern over {{days}} days, sorted by sets. The small \"X/7d\" number counts the last 7 of those days, useful to spot a single recent push (or a deliberate drop) that the longer window hides."
      },
      "empty": "No recent activity to compare",
      "pain": {
        "title": "Pain × volume",
        "help": "For every muscle flagged in your pain map, shows recent training load. Red dot = pain reported red (avoid heavy load), yellow = caution, green = monitor. The two volume numbers are the last 7 days and the whole {{days}}-day window on that muscle. Sustained heavy load on a red muscle is the highest-risk signal on this page.",
        "noPain": "No muscles flagged in your pain map",
        "sevRed": "Avoid",
        "sevYellow": "Caution",
        "sevGreen": "Monitor"
      },
      "trends": {
        "a11yUp": "progressing",
        "a11yFlat": "plateau",
        "a11yDown": "regressing",
        "title": "E1RM trends",
        "help": "For each movement pattern (squat, hinge, push, pull, …) shows the exercise with the highest top e1RM, counting only exercises with a trend worth reading: at least {{points}} points spread over at least {{spanDays}} days. Chart = e1RM points over {{days}} days (tap a point to read its value and date). Arrow = trend over those days: ↗ progressing, → plateau, ↘ regressing. A trained pattern where nothing reaches that bar says so instead of showing a number. An exercise untrained for over {{freshDays}} days hands its pattern to the one trained now, and stays on the chart behind it.",
        "fewData": "Few data points in {{days}} d",
        "noEligible": "No exercise with at least {{points}} points over {{spanDays}} days.",
        "notMeasurable": "Not measurable yet: no {{name}} set went near its limit. A set taken close to failure (an AMRAP) would show the strength here.",
        "machineNotMeasurable": "{{value}}, not measurable yet",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Show the other machine.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Show the other {{count}} machines.",
        "machineSessions_one": "{{count}} session",
        "machineSessions_other": "{{count}} sessions",
        "compareCtaA11y": "Change which exercise to compare {{pattern}} with",
        "compareSeparator": "vs",
        "compareClearA11y": "Clear your comparison for {{pattern}} and go back to the suggested one",
        "comparedManualA11y": "{{current}} compared with {{name}}, your choice",
        "comparedWithA11y": "{{current}} compared with {{name}}, which held this pattern before"
      },
      "repsAtLoad": {
        "a11yUp": "climbing",
        "a11yFlat": "flat",
        "a11yDown": "falling",
        "title": "Reps at load",
        "help": "For the exercises where you keep training the same load, this tracks the reps at that fixed weight over {{days}} days: the strength gain the e1RM chart can't see on high-rep and machine work. Bars = reps at the load, one per session (tap a bar for its date). Arrow = trend: ↗ climbing, → flat, ↘ falling. Only effort-tagged sets count, so more reps can't just mean an easier day.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Few data points in {{days}} d",
        "notMeasurable": "Not measurable yet: your {{name}} sets at {{load}} aren't tagged with effort, so more reps might just mean an easier day. A set taken near failure — or an effort tag — would show your strength here."
      },
      "period": {
        "all": "all"
      },
      "loadFailed": "Couldn’t load",
      "density": {
        "title": "Density",
        "help": "Volume divided by session duration, kg/min. Reads as \"how dense was that session\": going up means the same load in less time (better conditioning) or more load in the same time (better strength). A sudden drop without changing the program often means fatigue: the rests stretched, planned or not.",
        "empty": "Need 3+ timed sessions to chart density"
      },
      "frequency": {
        "title": "Stalest exercises",
        "help": "Top 8 exercises sorted by days-since-last-logged, stalest first. The X/{{days}}d suffix counts the sets of the last {{days}} days. A long gap means it was either cut on purpose or the program drifted. Useful to spot accessory work that quietly disappeared."
      },
      "intensityHeatmap": {
        "title": "Intensity heatmap",
        "help": "Per-exercise grid of completed sets sorted by rep range and intensity (% of 1RM). Strength range (85%+) at the bottom right, hypertrophy in the middle, endurance top left. Pick an exercise above to see where its sets cluster.",
        "exerciseLabel": "Exercise",
        "choosePrompt": "Choose an exercise",
        "noEligible": "Record a 1RM on at least one exercise to compute intensity.",
        "noMax": "No 1RM recorded for this exercise yet.",
        "totalSets": "{{n}} sets · 1RM {{max}}",
        "clear": "None"
      },
      "prTimeline": {
        "title": "PR timeline",
        "help": "MAXes over time, newest first. Tested means a confirmed single-rep PR; every other label is a starting estimate, not a tested max.",
        "empty": "No MAXes recorded yet.",
        "rowA11y": "{{name}}, {{value}}, {{date}}, {{source}}",
        "truncated_one": "Showing the last {{cap}} of {{count}} MAX",
        "truncated_other": "Showing the last {{cap}} of {{count}} MAXes",
        "source": {
          "manual": "Manual",
          "tested": "Tested",
          "derived": "Derived",
          "calculated_seed": "Starting value",
          "imported": "Imported",
          "unknown": "Unknown"
        },
        "helpPeriod": "The MAXes set in this period, newest first. Tested means a confirmed single-rep PR; every other label is a starting estimate, not a tested max.",
        "emptyPeriod": "No MAX set in this period."
      },
      "a11y": {
        "severityAlarm": "Alarm",
        "severityWarn": "Warning",
        "severityInfo": "Info"
      },
      "config": {
        "title": "Customize Progress",
        "open": "Customize Progress",
        "saveError": "Couldn't save your Progress layout. Please try again.",
        "widget": {
          "rhythm": "Training rhythm",
          "prTimeline": "PR timeline",
          "weekStreak": "Consistency streak"
        }
      },
      "coverageRefreshing": "Updating…",
      "report": {
        "open": "Create a report",
        "title": "Training report",
        "titleOf": "Training report: {{name}}",
        "period": "{{from}} to {{to}}",
        "from": "From",
        "to": "To",
        "pickA11y": "{{label}}: {{value}}. Change the date",
        "periodHint": "Any period up to {{days}} days, the past included.",
        "chooseSections": "Choose sections",
        "shareImage": "Share as image",
        "advanced": "Advanced report",
        "pdfExport": "Export as PDF",
        "comparePeriods": "Compare two periods",
        "sectionsTitle": "Report sections",
        "advancedSections": "Advanced sections",
        "noSections": "No section chosen. Choose the sections to see the report.",
        "sessions": "Sessions in the period",
        "frequencyHelp": "Sessions per week across the period.",
        "premiumHint": "Premium options are not part of the base report.",
        "shareNeedsSection": "Choose at least one section to share the report.",
        "pagesTruncated": "The shared report stops at {{max}} images. Choose fewer sections to share the rest.",
        "preparing": "Preparing image {{page}}…",
        "pagesReady": "The images are ready to share.",
        "adjustedToday": "A report ends today at the latest: the date moved to today.",
        "adjustedOther": "The other date moved to keep the period in order.",
        "adjustedCapped": "A report covers up to {{days}} days: the other date moved.",
        "emptyPeriod": "No training in this period."
      },
      "coverageNotConfirmed": "Couldn’t refresh — these are the last numbers we have"
    },
    "profile": {
      "title": "Profile",
      "navMaxes": "MAXes",
      "navMaxesSub": "Set, edit and review your MAXes per exercise.",
      "navCatalogSub": "Browse exercises, records and history.",
      "navRestTimer": "Timers",
      "navRestTimerSub": "Rest + hold defaults, sound, per-exercise",
      "labelEmail": "EMAIL",
      "labelApp": "APP VERSION",
      "labelBackend": "BACKEND VERSION",
      "labelPrivacy": "PRIVACY",
      "privacyHelp": "Export everything as JSON or delete the account permanently.",
      "legalLinkHint": "Opens in the browser",
      "exportButton": "Export my data",
      "deleteButton": "Delete my account",
      "deleteAlertTitle": "Delete account",
      "deleteAlertBody": "Your account, sessions, plans, programs and maxes will be permanently deleted. Deletions are not recoverable.",
      "deleteAlertCancel": "Cancel",
      "deleteAlertConfirm": "Delete",
      "signOut": "Sign out",
      "exportShareTitle": "$t(brand.product) export {{date}}",
      "labelLanguage": "Language",
      "languageHelp": "Pick the language used across the app. Saved on this device.",
      "languageCancel": "Close"
    },
    "timeline": {
      "setNumber": "Set {{n}}",
      "fail": "Fail",
      "failTip": "Fail logs the set as attempted but not completed. It still counts as done (the rest timer runs), shows ✕ in the timeline, and is left out of your e1RM.",
      "failTipA11y": "What does Fail mean?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% of best",
      "e1rmNewBest": "best",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-rep",
      "dropsetTag": "Drop",
      "myorepA11y": "Myo-rep set",
      "dropsetA11y": "Drop set",
      "setVolumeA11y": "Set volume {{value}} {{unit}}",
      "noBodyweight": "No bodyweight yet",
      "approachBadge": "Warm-up",
      "approachBadgeA11y": "approach set, not counted as a working set",
      "setSummaryBothSidesA11y": "{{reps}} reps at {{weight}} {{unit}} per side, both sides counted",
      "e1rmLegendA11y": "What is e1RM?",
      "e1rmTip": "e1RM is your estimated 1-rep max for the set (Epley, reps ≤ 12). “% of best” compares it to your best e1RM in recent history — lower means room to push; ↑ best means a new estimated record.",
      "durationLabel": "Duration",
      "hourShort": "h",
      "minShort": "min",
      "secShort": "sec",
      "started": "Workout started",
      "addSet": "Add set",
      "insertSetBefore": "Insert a set before set {{n}}",
      "removeSet": "Remove set",
      "prevSet": "Previous set",
      "nextSet": "Next set",
      "allLogged": "All sets logged — tap + to add another.",
      "rosterLabel": "Exercises",
      "rosterHint": "tap to switch",
      "focusEmptyHasRoster": "Select an exercise above to start, or add a new one.",
      "focusAllLogged": "All sets logged. Add an exercise above, or save below.",
      "cueNextSet": "→ Set {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Expand exercise list",
      "rosterCollapseA11y": "Collapse exercise list",
      "rosterState": {
        "done": "done",
        "inProgress": "in progress",
        "notDone": "not started"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} of {{count}})",
      "exerciseNote": "Exercise note",
      "notePlaceholder": "Add a note to the timeline…",
      "noteSend": "Send note",
      "noteExpandA11y": "Note — tap to read in full",
      "noteDeleteA11y": "Delete note",
      "uncompleteSetA11y": "Remove set {{n}} of {{exercise}} — it goes back to be redone",
      "dropsetActive": "Dropset — edit the rounds below.",
      "editingLogged": "Editing logged set {{n}} — changes save with the workout.",
      "addSetLocked": "Editing a past session: you can't add sets. Fix the values or remove a set instead.",
      "createGroupLocked": "Editing a past session: you can't create a superset.",
      "splitGroupLocked": "Editing a past session: you can't dissolve a superset.",
      "setTypeLocked": "Editing a past session: you can't change the set type (dropset/myorep).",
      "addStepLocked": "Editing a past session: you can't add a dropset step.",
      "setState": {
        "pending": "Set {{n}} of {{total}}, not done",
        "done": "Set {{n}} of {{total}}, done",
        "pr": "Set {{n}} of {{total}}, personal record",
        "failed": "Set {{n}} of {{total}}, failed"
      },
      "holdLabel": "Hold"
    },
    "summary": {
      "prBadge": "personal record"
    },
    "logger": {
      "title": "New workout",
      "cancel": "Cancel",
      "swapKindTitle": "Change exercise type?",
      "swapKindBody": "This exercise is logged a different way, so the sets you already logged here will be cleared.",
      "swapKindConfirm": "Change & clear",
      "failConfirmTitle": "Clean reps",
      "failConfirmBody_one": "Saving {{count}} clean rep. The failed one does not count.",
      "failConfirmBody_other": "Saving {{count}} clean reps. The failed one does not count.",
      "failConfirmHint": "Adjust if you did more or fewer than that.",
      "failConfirmStepDown": "One fewer clean rep",
      "failConfirmStepUp": "One more clean rep",
      "failConfirmSave": "Save",
      "amrapConfirmTitle": "Did you go to failure?",
      "amrapConfirmBody": "Answer yes only if the next rep would not have come up.",
      "amrapNeedsReps": "Type the reps you did to log this set.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: at least {{reps}} reps, then as many as possible",
      "amrapConfirmAtFloor": "You logged {{reps}}, and the plan asked for at least {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Yes, to failure",
      "amrapConfirmNo": "No, I had more in me",
      "failBadge": "Failed",
      "failBadgeA11y": "failed set",
      "save": "Save",
      "remove": "Remove",
      "replace": "Replace",
      "addExercise": "Add exercise",
      "addSet": "Add set",
      "addRound": "Add round",
      "pickerTitle": "Pick exercise",
      "pickerSearch": "Search exercises",
      "pickerResultsN_one": "{{count}} result",
      "pickerResultsN_other": "{{count}} results",
      "pickerEmpty": "No exercises match.",
      "pickerClearFilters": "Clear filters",
      "pickerFilters": "Filters",
      "pickerFiltersN": "Filters ({{n}})",
      "empty": "No exercises yet. Add one to start logging.",
      "setReps": "REPS",
      "amrapPrescribedA11y": "AMRAP: at least the target reps, then as many as possible",
      "setPercentOfMax": "%",
      "prescribedLoadTip": "The load you're prescribing, in the unit the program is written in. Kilos or a % of max — that's set just below.",
      "setPercentOfMaxA11y": "Percent of max",
      "stepAdd": "Step up",
      "stepSubtract": "Step down",
      "amrapChipPrescribe": "Prescribe as many reps as possible",
      "tipAmrapPrescribe": "Asks the athlete for as many reps as possible on this set. The rep count stays as the floor to reach first.",
      "entryNoteEdit": "Edit the exercise note",
      "entryNoteAdd": "＋ Exercise note",
      "setWeightBothSidesA11y": "Weight of one side, both sides counted ({{unit}})",
      "setTypeWorking": "Working",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-rep",
      "setCommentLabel": "Set comment",
      "unitLabel": "Unit",
      "discardTitle": "Discard workout?",
      "discardBody": "You will lose the entries you have logged so far.",
      "discardCancel": "Keep logging",
      "discardConfirm": "Discard",
      "discardEditTitle": "Discard changes?",
      "discardEditBody": "The saved workout stays as it was.",
      "discardEditCancel": "Keep editing",
      "errNoEntries": "Add at least one exercise.",
      "errNoSets": "Each exercise needs at least one set with reps and weight.",
      "errInvalid": "The workout can't be saved as is.",
      "errSaveFailed": "Save failed. The workout is still here: tap Save again.",
      "errNotSignedIn": "Not signed in. The workout stays here; save it after you sign in again.",
      "errSetsUnknownExercise": "An exercise in this workout isn't recognized. Change it and save again.",
      "errSetsInvalidTag": "A tag on a set isn't accepted. Remove it and save again.",
      "errSetsInvalid": "Some sets aren't valid. Check weight and reps, then save again.",
      "errSetsNotSaved": "Some sets didn't reach the server. Try saving again.",
      "errCorrectionTooBig": "Too many sets changed at once. Save fewer changes, then the rest.",
      "errCorrectionBusy": "The workout was busy. Wait a moment and save again.",
      "errCorrectionConflict": "This workout changed on another device. Close it, reopen it and correct it again.",
      "errCorrectionStale": "This workout was saved again after you opened it. Close it, reopen it and correct it again.",
      "errCorrectionTimes": "The workout ends before it starts. Check start and end, then save.",
      "errCorrectionImport": "This workout came from Health Connect and can't be corrected here. Correct it in Health Connect.",
      "errCorrectionGone": "This workout was deleted on another device. Your correction is not lost: find it at the top of Workouts and tap Save as new.",
      "errCorrectionGoneHere": "This workout was deleted on another device. Your correction is not lost: tap Save as new to keep it as a new workout.",
      "correctionToBell": "Your earlier correction of this workout was refused, and this one joined it. It is not lost: find it at the top of Workouts and tap Save as new.",
      "setNumberHeader": "SET",
      "removeSetA11y": "Remove this set",
      "serverErrorTitle": "SERVER REJECTED THE SAVE",
      "serverErrorHint": "Adjust the workout and try again. If the message is unclear, share it with your coach.",
      "setExtra": "EXTRA",
      "setWeightTip": "Weight lifted per set. Switch kg/lb with the unit chip on each row.",
      "setExtraTip": "Bodyweight assistance or added load. Type a minus (−) for band/machine assist (the field turns amber); a belt/plate add is positive.",
      "setWeightMixedTip": "Mixed group: barbell/stack load on weighted rows, ± extra on bodyweight rows (minus = assist).",
      "editTitle": "Edit workout",
      "planTitle": "Plan",
      "programTitle": "Program",
      "repeatTitle": "Repeat workout",
      "minimize": "Minimize workout",
      "closeWorkout": "Close workout",
      "saveWorkout": "Save workout",
      "bilateral": "Bilateral",
      "unilateral": "Unilateral",
      "plates": "Plates",
      "numInvalid": "Invalid number",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "1–10 effort",
      "setNoteLabel": "Note",
      "setNotePlaceholder": "Cue, form check, sensation…",
      "totalsSets_one": "{{count}} set",
      "totalsSets_other": "{{count}} sets",
      "totalsReps_one": "{{count}} rep",
      "totalsReps_other": "{{count}} reps",
      "totalsTitle": "Workout totals",
      "totalsVolume": "Volume",
      "totalsSetsShort": "Sets",
      "totalsRepsShort": "Reps",
      "totalsByMuscle": "Work by muscle",
      "restRest": "Rest",
      "startRestManual": "Start rest timer",
      "restSkip": "Skip",
      "restWord": "Rest",
      "restAddStep": "+{{n}} seconds",
      "restSubtractStep": "−{{n}} seconds",
      "restStartedA11y": "Rest started, {{time}}.",
      "restEndedA11y": "Rest over.",
      "restInviteLabel": "Rest a bit longer?",
      "restInviteAdd": "+{{time}}",
      "restInviteAddA11y": "Add {{time}} to the rest",
      "restInviteA11y": "Rest a bit longer? You can add {{time}}.",
      "setsCarriedOverA11y": "Sets carried over from last time.",
      "restInviteTipTitle": "Why rest longer?",
      "restInviteTipBody": "That set ended at or near failure. In studies, longer rests after sets like this kept more strength for the next set: about 3 min, up to 5 on heavy lifts. How long you rest is up to you.",
      "loadBarA11y": "Weight controls",
      "restBarA11y": "Rest timer",
      "restRemainingA11y": "{{time}} of rest remaining",
      "restEditA11y": "Set default rest for this exercise",
      "restEditTitle": "Default rest",
      "restEditBody": "Save this rest as default for {{name}}",
      "restEditSave": "Save",
      "restEditSaving": "Saving…",
      "restEditError": "Could not save the default rest. Try again.",
      "restEditCancel": "Cancel",
      "restEditSaveAsGlobal": "Use as global default",
      "restStepMinus": "Decrease by {{step}} seconds",
      "restStepPlus": "Increase by {{step}} seconds",
      "restPause": "Pause",
      "restResume": "Resume",
      "restExpiredTitle": "Rest over",
      "holdExpiredTitle": "Time's up",
      "restExpiredBody": "Time to lift again.",
      "holdExpiredBody": "Tap the effort band to log the set.",
      "boutExpiredTitle": "Bout done",
      "boutExpiredBody": "Set logged for you.",
      "workStartedTitle": "Go",
      "cueLeadInWork": "Work — {{n}} s",
      "cueLeadInRest": "Rest — {{n}} s",
      "cueChannel": {
        "tick": "Countdown ticks",
        "work": "Work starts"
      },
      "boutAutoLoggedA11y": "Bout done, {{time}} logged.",
      "workoutFgsTitle": "Workout in progress",
      "workoutFgsBodyNamed": "{{name}} · tap to resume",
      "workoutFgsBody": "Tap to resume your session",
      "descriptionToggle": "Show / hide description",
      "notesToggle": "Notes for this workout",
      "infoButton": "Info",
      "notesEmpty": "No notes for this session",
      "notesProgramLabel": "Program",
      "notesWorkoutLabel": "This workout",
      "note": "Note",
      "rpeChip": "RPE",
      "historyChip": "History",
      "more": "More actions",
      "addGroup": "Create a superset with another exercise",
      "cardioDuration": "Duration",
      "cardioDurationPlaceholder": "Seconds",
      "cardioDistance": "Distance",
      "cardioWeight": "Weight",
      "cardioHr": "Avg HR",
      "cardioCalories": "Calories",
      "cardioOptionalsShow": "Show other fields",
      "cardioOptionalsHide": "Hide other fields",
      "dateEditor": "Date & duration",
      "dateLabel": "Date",
      "startTimeLabel": "Start",
      "endTimeLabel": "End",
      "durationLabel": "Duration",
      "historyToggle": "History",
      "historyBest": "Best",
      "historyCopy": "Copy",
      "historyBodyweight": "{{reps}} reps BW",
      "historyEstimateHeader": "Estimate from a similar exercise",
      "historyEstimatedFrom": "From {{name}}",
      "historyNoEstimate": "No history yet, and no similar exercise to estimate from.",
      "copyDialogTitle": "Copy session",
      "copyDialogBody": "Replace pending sets or add to existing?",
      "copyOverwrite": "Replace",
      "copyAppend": "Add",
      "resumeDiscard": "Discard",
      "conflictTitle": "Workout in progress",
      "conflictBody": "You're already logging a workout. Keep it running, or show it to save or discard.",
      "nameLabel": "Workout name",
      "namePlaceholder": "Name: e.g. Push…",
      "editNameA11y": "Edit workout name",
      "setStateA11y": "set {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "unit {{unit}}",
      "stepperPositive": "positive",
      "stepperNegative": "negative",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Easy",
      "effortMeterHard": "Hard",
      "effortWord": "Effort",
      "holdSlotDone": "DONE",
      "holdSlotHeld": "HELD",
      "holdSlotDoneA11y": "{{time}} done",
      "holdSlotFailedA11y": "{{time}}, failed",
      "holdSlotHeldA11y": "{{time}} held",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "target",
      "effortQuestionRir": "Reps in reserve?",
      "effortQuestionRpe": "How hard was it?",
      "effortQuestionHint": "Opens the effort scale — how it works and how to switch it",
      "effortMeterHintLog": "Also logs the set as completed",
      "effortMeterHintRunning": "Stops the timer and logs the set",
      "effortMeterHintEdit": "Updates the effort of this logged set",
      "effortMeterFailHintLog": "Logs the set as failed",
      "effortMeterFailHintEdit": "Switches this set between done and failed",
      "effortMeterTapCta": "Tap to log the set",
      "effortMeterStopCta": "Tap to stop and log",
      "effortNudgeOptOut": "Turn off reminder",
      "effortNudgeOptOutHint": "Asks you to confirm first. You can turn it back on in Settings.",
      "effortNudgeOptOutConfirmTitle": "Turn off this reminder?",
      "effortNudgeOptOutConfirmBody": "You can turn it back on anytime in Settings.",
      "effortNudgeOptOutConfirmButton": "Turn off",
      "effortMeterAmrapDone": "Done",
      "effortMeterAmrapHint": "Logs the set at failure — no reps left",
      "amrapChip": "As many reps as possible",
      "burnPlus": "Burn+",
      "burnPlusChip": "Burn+ intensity technique (dropset / myo-rep)",
      "loadAxisTitle": "What determines the load",
      "timedChip": "Timed",
      "noteChip": "Note",
      "noteClose": "Done",
      "effortLegendA11y": "Effort scale help",
      "rirLegendTitle": "RIR: reps in reserve",
      "rirLegendBody": "0 = no reps left\n1 = 1 rep left\n2 = 2 reps left\n3 = comfortable margin — still a working set\n4–5 = light work, not counted\n6+ = warm-up",
      "rpeLegendTitle": "RPE: rate of perceived exertion",
      "rpeLegendBody": "10 = no reps left\n9 = 1 rep left\n8 = 2 reps left\n7 = comfortable margin — still a working set\n5–6 = light work, not counted\n4 or less = warm-up",
      "timerStartCountdown": "Start countdown",
      "timerStartCountup": "Start stopwatch",
      "timerSettings": "Timer defaults for this exercise",
      "holdHeaderHours": "h",
      "holdHeaderMinutes": "min",
      "holdHeaderSeconds": "s",
      "holdHours": "Hours",
      "holdMinutes": "Minutes",
      "holdSeconds": "Seconds",
      "holdSubTen": "-10s",
      "holdAddTen": "+10s",
      "holdCancel": "Cancel",
      "holdClockElapsedA11y": "{{time}} elapsed",
      "holdClockOvertimeA11y": "{{time}} past the target",
      "pausedReadoutA11y": "{{label}}, paused",
      "holdClockRemainingA11y": "{{time}} remaining",
      "holdFlip": "Switch direction",
      "holdExtraWeight": "Extra",
      "lateralityTipUni": "UNI · log one side; volume counts both (×2).",
      "lateralityTipBi": "BI · bilateral load; volume counts once (×1).",
      "tabExercises": "Exercises",
      "tabSuperset": "Superset",
      "pickerAddN": "Add {{n}}",
      "pickerAlreadyInWorkout": "Already in this workout",
      "pickerAlreadyInBlock": "Already in this block",
      "pickerPin": "Pin favourite",
      "pickerUnpin": "Unpin favourite",
      "noteReadA11y": "Exercise note — tap to read in full",
      "prescriptionReadA11y": "Prescribed set cue — tap to read in full",
      "tipAmrap": "As many reps as possible — take this set to technical failure.",
      "tipBurnPlus": "Intensity techniques — reveal Dropset or Myo-rep to push a set past failure.",
      "targetEyebrow": "Target",
      "historySetCount": "last {{n}} sets",
      "historyBlinkToggle": "Blink when an exercise has not been done in a while",
      "historyCopyLast": "Copy the last session",
      "historyLooking": "Looking up this exercise…",
      "historyUnavailable": "Can't reach your history right now — this doesn't mean there is none.",
      "historyBlinkOn": "Blink on",
      "historyBlinkOff": "Blink off",
      "historyToggleAged": "History, last done {{age}}",
      "maxEditNoneA11y": "Set your max for this exercise",
      "maxEditA11y": "Change your max",
      "maxEditStaleA11y": "Change your max, last set {{age}}",
      "maxHeaderNone": "No max yet",
      "maxHeaderValue": "MAX {{weight}}",
      "maxHeaderStale": "MAX {{weight}} · {{age}}",
      "proposedWeightTipTestedMax": "Proposed so this set lands on {{effort}}, worked back from the 1RM you tested. A starting point, not a prescription — change it.",
      "proposedWeightTipMax": "Proposed so this set lands on {{effort}}, worked back from your recorded max. A starting point, not a prescription — change it.",
      "proposedWeightTipHistory": "Proposed so this set lands on {{effort}}, worked back from your last set on this exercise. A starting point, not a prescription — change it.",
      "historySectionComputed": "Where this weight comes from",
      "historyProposalSource_one": "From your last session of {{name}}",
      "historyProposalSource_other": "From your last {{count}} sessions of {{name}}",
      "historyProposalAxisReps": "More reps, same weight",
      "historyProposalAxisLoad": "More weight, same reps",
      "historyProposalAxisTrade": "Trade reps for weight",
      "historyInUse": "in use",
      "historyCopyWeightA11y": "Use this weight on the set you're on",
      "historyCopySetA11y": "Copy this set onto the set you're on",
      "historyNone": "You haven't logged this exercise yet.",
      "historySourceTestedMax": "To land on {{effort}} — from the 1RM you tested",
      "historySourceMax": "To land on {{effort}} — from your recorded max",
      "historySourceLastSet": "To land on {{effort}} — from your last set here",
      "historySourcePercent": "A percentage of your max, set by the program",
      "historySourcePrescribed": "The weight written in the program",
      "historySourceLastWeight": "The last weight you actually used here",
      "historySourceManual": "You typed this one yourself",
      "historySourcePercentOf": "{{pct}}% of your max, set by the program",
      "draftToday": {
        "status": "Draft · not saved",
        "title": "Today's session",
        "exercises_one": "{{count}} exercise",
        "exercises_other": "{{count}} exercises",
        "scope": "For the muscles below minimum volume that you haven't trained in the last {{hours}} hours.",
        "scopeMav": "For the muscles below minimum volume, then those below MAV, that you haven't trained in the last {{hours}} hours.",
        "scopeAnyway": "Rest ignored: the muscles you trained longest ago come first.",
        "reason_one": "<b>{{muscle}}</b>: {{n}} set to the minimum this week",
        "reason_other": "<b>{{muscle}}</b>: {{n}} sets to the minimum this week",
        "reasonMav_one": "<b>{{muscle}}</b>: {{n}} set under MAV this week",
        "reasonMav_other": "<b>{{muscle}}</b>: {{n}} sets under MAV this week",
        "lastTrained": "last trained {{age}}",
        "noHistory": "Never done · no reps or kg yet",
        "reps": "reps",
        "painVeto": "Left out for {{parts}} (pain map): {{muscles}}.",
        "source": "Reps: your best set of the last 8 weeks. Kg: worked out for 3 reps in reserve. Nothing is saved until you start.",
        "discard": "Discard draft",
        "timeA11y": "Time available",
        "minutes": "{{n}} min",
        "estimate": "~{{n}} min",
        "shuffleRowA11y": "Another exercise for {{muscle}}",
        "shuffleAllA11y": "Other exercises for every muscle",
        "shuffleAll": "Shuffle all",
        "allSets_one": "applies to all {{n}} sets",
        "allSets_other": "applies to all {{n}} sets",
        "intensityChoice": "{{n}}%",
        "intensityA11y": "Intensity: share of the weekly volume",
        "intensityChipA11y": "{{n}}% of the weekly volume",
        "intensityToday": "today at {{n}}%",
        "surprise": "Surprise me",
        "surpriseHint": "Random exercises instead of the ones you do most",
        "anchorOwn": "From your best set, {{date}} · {{age}}",
        "anchorSimilar": "Reps from {{name}} · no kg for this one yet",
        "timeTitle": "Time (min)",
        "intensityTitle": "Intensity",
        "restTitle": "Rest",
        "restChoice": "{{n}} h",
        "restA11y": "Rest: a muscle trained within this time stays out",
        "restChipA11y_one": "{{count}} hour",
        "restChipA11y_other": "{{count}} hours",
        "restingUntil": "{{muscles}}: resting until {{day}}",
        "atMinimum": "Every muscle is at its weekly minimum.",
        "buildAnyway": "Build one anyway",
        "newWorkout": "New workout"
      },
      "pin": "Pin",
      "pinned": "pinned",
      "hintTitle": "Tap to swap this exercise.",
      "hintHowTo": "How to do this exercise.",
      "hintTarget": "Sets this week per muscle.",
      "hintTrash": "Removes this exercise from the workout.",
      "hintClock": "Past sets of this exercise.",
      "hintSuperset": "Superset: pair with another exercise and alternate sets.",
      "hintSupersetCue": "Superset: tap to go to its next exercise.",
      "hintSupersetMenu": "Superset options: add, reorder, remove or dissolve.",
      "hintWeek": "Tap for the next week. Swipe the grid to go back.",
      "hintTimed": "Timed: this set is held for a time, not counted in reps.",
      "hintNote": "Note: write a cue for this set.",
      "hintDropsetRemove": "Back to a single working set.",
      "hintPinOn": "Pinned: stays in focus after the rest. Tap to unpin.",
      "hintPinOff": "Pin: keeps this exercise in focus when the rest ends.",
      "holdHintIntro": "Hold any button to see what it does.",
      "showHint": "Show hint",
      "pickerInDays": "In which days",
      "pickerAddNInDays_one": "Add {{n}} in {{count}} day",
      "pickerAddNInDays_other": "Add {{n}} in {{count}} days",
      "repsRangeA11y": "Rep range {{min}} to {{max}}"
    },
    "coachEdges": {
      "empty": "No coach edges yet. A coach can invite you from the web app."
    },
    "recovery": {
      "banner": "Recovered workout",
      "orphanedBanner": "You corrected this workout, but its session was deleted on another device. Tap Save as new to keep your correction as a new workout.",
      "tooBigBanner": "Your correction changed too many sets to save in one go, so the workout stayed as it was. Tap Save as new to keep your version as a new workout.",
      "conflictBanner": "This workout changed on another device before your correction arrived, so it stayed as it was. Tap Save as new to keep your correction as a new workout.",
      "timesBanner": "Your correction ends before it starts, so the workout stayed as it was. Tap Save as new, fix the times, then save.",
      "staleBanner": "This workout was saved again after you started this correction. It stayed as it was. Tap Save as new to keep your correction.",
      "refusedBanner": "The server refused your correction, so the workout stayed as it was. Tap Save as new to keep your version as a new workout.",
      "saveAsNew": "Save as new",
      "title": "Recovered workout",
      "openBody": "This workout was interrupted and recovered. Check the sets and tap Save to log it as a new workout.",
      "open": "Open",
      "cancel": "Cancel",
      "liveBusy": "You have a workout in progress. Save or discard it before recovering this one.",
      "discardTitle": "Discard recovered workout?",
      "discardBody": "This recovered workout will be permanently deleted.",
      "discardConfirm": "Discard",
      "error": "Couldn't recover the workout. Try again.",
      "mergeTitle": "Merge workout",
      "mergePrompt": "Pick a same-day workout to merge into:",
      "noSameDay": "No same-day workout to merge into. Use \"Save as new\".",
      "nothingToMerge": "No completed sets to merge. Use \"Save as new\".",
      "supportPrefix": "Workout kept on this phone after a crash, sent from the bell. Draft JSON attached."
    },
    "group": {
      "title": "Group this exercise",
      "close": "Close",
      "standalone": "Standalone",
      "supersetSection": "SUPERSETS",
      "circuitSection": "CIRCUITS",
      "supersetN": "Superset {{n}}",
      "circuitN": "Circuit {{n}}",
      "newSuperset": "+ New superset",
      "newCircuit": "+ New circuit"
    },
    "webview": {
      "close": "Close",
      "openExternal": "Open in browser",
      "errorTitle": "The page didn't load",
      "errorBody": "Tap below to try the system browser instead.",
      "fallbackErrorTitle": "Couldn't open the browser",
      "fallbackErrorBody": "Try again from a different network."
    },
    "plates": {
      "title": "Plate calculator",
      "close": "Close",
      "apply": "Apply",
      "targetLabel": "Target",
      "barLabel": "Bar ({{unit}})",
      "barOptionLabel": "Bar — {{weight}}",
      "barCustom": "Custom…",
      "barCustomLabel": "Custom bar weight",
      "perSide": "Per side: {{weight}}",
      "barOnly": "Empty bar — no plates needed.",
      "pairs_one": "{{count}} pair",
      "pairs_other": "{{count}} pairs",
      "plates_one": "{{count}} plate",
      "plates_other": "{{count}} plates",
      "loadedSide": "Loaded side: {{weight}}",
      "singleSideHint": "One side only: the plates go on a single side. Landmine, T-bar, sleds and per-arm levers load this way.",
      "remainder": "Off by {{weight}} — inventory can't match exactly.",
      "belowBar": "Target is below the bar weight.",
      "invalid": "Enter a valid weight.",
      "inventoryTitle": "Pairs available ({{unit}})",
      "pairsIncrement": "Add a pair — {{weight}}",
      "pairsDecrement": "Remove a pair — {{weight}}",
      "signLabel": "EXTRA SIGN",
      "signAdd": "+ Weighted",
      "signAssist": "− Assist",
      "loadShapeLabel": "How it loads",
      "loadShapeTwoSides": "Two sides",
      "loadShapeOneSide": "One side",
      "loadShapeTwoSidesHint": "pairs",
      "loadShapeOneSideHint": "single stack",
      "composeTitle": "Plates ({{unit}}) — tap to add",
      "composeEmpty": "No plates set up — set the pairs you own below.",
      "composeAddPair": "Put a {{weight}} pair on the bar",
      "composeAddPlate": "Put a {{weight}} plate on the bar",
      "composeRemovePair": "Take a {{weight}} pair off the bar",
      "composeRemovePlate": "Take a {{weight}} plate off the bar",
      "roundToLoadable": "Round to a loadable weight",
      "calcOpen": "Calculator",
      "calcResult": "Result: {{value}} {{unit}}",
      "calcClearKey": "C",
      "calcClear": "Clear",
      "calcDecimal": "Decimal point",
      "calcOpPlus": "Plus",
      "calcOpMinus": "Minus",
      "calcOpTimes": "Times",
      "calcOpDivide": "Divided by",
      "calcDismiss": "Close",
      "calcCopy": "Copy into weight",
      "calcCopyBlocked": "Add up a weight above zero first."
    },
    "restTimerScreen": {
      "title": "Timers",
      "back": "Back"
    },
    "licenses": {
      "title": "Open source licenses",
      "back": "Back",
      "headlineIntro": "$t(brand.product) leans on a small set of libraries that materially shape the app. Tap a row to open the project — and consider sponsoring the ones you use the most.",
      "coreSection": "Core libraries ({{count}})",
      "viewAllTitle": "View all packages",
      "viewAllSub": "Full attribution for the {{count}} packages bundled in the APK, grouped by project.",
      "allTitle": "All packages ({{count}})",
      "searchAll": "Search name, group, license or author",
      "groupOther": "Other packages",
      "empty": "No package matches that search.",
      "footer": "Generated {{date}}",
      "openErrorTitle": "Cannot open link"
    },
    "share": {
      "newPR": "NEW PR",
      "topLifts": "TOP LIFTS",
      "durationMinute": "min",
      "durationHour": "h",
      "durationMinuteShort": "m",
      "footerSets": "sets",
      "footerDensitySuffix": "/min",
      "fallbackLabel": "Total Volume",
      "timeLabel": "Total Time",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impulse",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Calories",
      "blockEffort": "Effort",
      "blockDistance": "Distance",
      "effortHr": "{{avg}} avg · {{peak}} peak bpm",
      "effortHrMax": "{{pct}}% HRmax",
      "shareTitle": "$t(brand.product) session",
      "shareErrorTitle": "Share failed",
      "headlineLabelPR": "NEW E1RM",
      "headlineLabelDelta": "BIG JUMP +{{delta}}",
      "headlineLabelSolid": "SOLID SESSION",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} sets",
      "blockTopLifts": "Top Lifts",
      "fromSet": "from {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Duration",
      "blockDensity": "Density",
      "blockNotes": "Notes",
      "barsTitle": "Work by muscle",
      "bodyTitle": "Muscles worked",
      "sharing": "Preparing…",
      "shareCta": "Share session card",
      "done": "Done",
      "summaryTitle": "Workout saved",
      "maxProposed_one": "New MAX proposed for {{exercises}}: it's in your notifications.",
      "maxProposed_other": "New MAXes proposed for {{exercises}}: they're in your notifications."
    },
    "common": {
      "back": "Back",
      "save": "Save",
      "cancel": "Cancel",
      "close": "Close"
    },
    "account": {
      "title": "Account",
      "labelDiagnostics": "DIAGNOSTICS",
      "navSub": "Name, password, export, delete, sign out",
      "nameLabel": "NAME",
      "namePlaceholder": "Your name",
      "saved": "Saved",
      "passwordLabel": "CHANGE PASSWORD",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "passwordChanged": "Password changed.",
      "passwordSubmit": "Update password",
      "deleteNeedsConnection": "Deleting your account needs a connection. Reconnect and try again — this request is never saved for later."
    },
    "prefs": {
      "title": "Units & display",
      "navSub": "Units, language, hints",
      "unitsLabel": "Units",
      "unitsHelp": "Default weight unit for new sets. You can still override per row in the logger.",
      "weekStartLabel": "Week starts on",
      "weekStartHelp": "Which day your training week resets. Weekly muscle targets count from this day.",
      "unitsKg": "Kilograms (kg)",
      "unitsLb": "Pounds (lb)",
      "glucoseUnitsLabel": "Glucose units",
      "glucoseUnitsHelp": "How glucose is shown and entered. Stored the same either way.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Theme palette",
      "themePaletteHelp": "Pick the colour palette used across the app.",
      "themeModeLabel": "Appearance",
      "themeModeHelp": "Follow the system setting, or force light or dark.",
      "themeMode": {
        "system": "System",
        "light": "Light",
        "dark": "Dark"
      }
    },
    "home": {
      "targetsTopPatterns": "Top patterns",
      "targetsSummary": "{{on}} of {{total}} on target",
      "targetsHint": "Pin a program with weekly targets to score these against a goal.",
      "targetsZoneOnTarget": "on target",
      "targetsZoneOver": "over",
      "targetsZoneUnder": "building",
      "targetsNoCoverage": "no coverage",
      "targetsIncomplete": "incomplete",
      "targetsIncompleteWhy": "An exercise logged this week is not in the catalog, so its sets count toward no muscle.",
      "targetsIncompleteNoBodyweight": "A session this week was saved before your bodyweight was on your profile, so its bodyweight sets count as zero. The admin recomputes it: you don't need to do anything.",
      "targetsIncompleteMayBeHigher": "The real number may be higher.",
      "targetsIncompleteA11y": "Why incomplete",
      "targetsPrescribed": "plan {{n}}",
      "targetsEmptyTitle": "No goals yet",
      "targetsEmptySub": "Set how much you want to train each muscle per week. Your plan works toward it; the Home meter shows where you are.",
      "targetsEmptyCta": "Set your goals",
      "weekEyebrow": "This week",
      "weeklySessions": "Workouts",
      "weeklyVolume": "Volume",
      "weeklyA11y": "{{sessions}} workouts, {{volume}} volume",
      "viewProgress": "View progress",
      "badgesTitle": "Badges",
      "prPrev": "Previous record",
      "prNext": "Next record",
      "prPosition": "Record {{n}} of {{total}}",
      "eyebrow": "TODAY",
      "blankTitle": "Ready to train?",
      "blankLoading": "Loading your plan…",
      "blankBody": "No active program right now. $t(brand.product) has ready-made programs in the library: follow one with a tap. Or start a blank workout.",
      "blankLibrary": "Browse ready-made programs",
      "newWorkout": "New workout",
      "programMeta": "{{program}} · Week {{week}}",
      "morePreview": " +{{count}} more",
      "startToday": "▶ Start session",
      "blankInstead": "Start a blank workout instead",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} reps BW",
      "weightTitle": "Body weight",
      "weightSaved": "Saved ✓",
      "weightCurrent": "Latest: {{weight}}",
      "weightNone": "Log your weight to track trends.",
      "weightSave": "Save",
      "repeatWorkout": "Repeat a past workout",
      "form": {
        "title": "Readiness",
        "ready": "Ready",
        "caution": "Caution",
        "rest": "Rest",
        "reasonNoData": "Log a session to start tracking your readiness.",
        "reasonBalanced": "Your training load looks balanced.",
        "reasonFreshStart": "Getting back into it — ease in and build a base.",
        "reasonShortRest": "Back-to-back sessions — keep an eye on recovery.",
        "reasonHighFrequency": "A high-volume week — consider a lighter day.",
        "reasonLoadSpike": "Your load jumped sharply vs your recent average.",
        "reasonLongGap": "It's been a while — start light to ramp back up."
      },
      "glucoseSave": "Save",
      "weightSaveA11y": "Save body weight",
      "glucoseSaveA11y": "Save glucose reading",
      "config": {
        "title": "Customize Home",
        "open": "Customize Home",
        "active": "Active",
        "inactive": "Inactive",
        "dragHint": "Drag a card by its handle to reorder.",
        "inactiveEmpty": "Nothing hidden. Tap ✕ on a card to hide it.",
        "pinned": "Always shown",
        "hide": "Hide {{name}}",
        "show": "Show {{name}}",
        "reorder": "Reorder {{name}}",
        "reorderKeys": "Reorder {{name}}, use arrow keys",
        "reorderHint": "Drag to move, or use the actions to move up or down.",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "reset": "Reset to default",
        "saveError": "Couldn't save your Home. Please try again.",
        "widget": {
          "hero": "Today",
          "readiness": "Readiness",
          "weeklyTargets": "This week",
          "quickWeight": "Body weight",
          "quickGlucose": "Glucose",
          "badges": "Badges",
          "coverage": "Muscle coverage",
          "e1rmTrends": "E1RM trends",
          "repsAtLoad": "Reps at load",
          "movementBalance": "Movement balance",
          "painVolume": "Pain × volume",
          "intensityHeatmap": "Intensity heatmap",
          "exerciseFrequency": "Stalest exercises",
          "painMap": "Pain map",
          "measurements": "Measurements"
        },
        "columnMain": "Main column",
        "columnRail": "Side column",
        "columnEmpty": "No cards in this column."
      },
      "painMapEmpty": "No pain marked.",
      "painMapOpenHint": "Opens your pain map to edit."
    },
    "superset": {
      "startingWith": "Starting superset with",
      "joinExisting": "Join existing",
      "pairInWorkout": "Pair with (in this workout)",
      "templates": "Saved supersets",
      "templateInsertHint": "Insert this superset; long-press to delete",
      "templateDeleteBody": "Remove this saved superset?",
      "createCta": "Create superset ({{n}})",
      "cueCycle": "{{group}}, exercise {{pos}} of {{total}}. Tap to go to {{next}}.",
      "cueStatic": "{{group}}, exercise {{pos}} of {{total}}",
      "menuOpen": "Superset options",
      "menuSaveTemplate": "Save as template",
      "menuAddExercise": "Add exercise",
      "menuMoveUp": "Move up",
      "menuMoveDown": "Move down",
      "menuRemoveMember": "Remove this exercise",
      "menuSplit": "Dissolve superset",
      "namePlaceholder": "Superset name (optional)"
    },
    "premium": {
      "badge": "Premium",
      "lockedA11y": "{{name}}, Premium, not part of the base report"
    },
    "widgetConfig": {
      "stateClosed": "Closed",
      "stateOpen": "Open",
      "expand": "Expand {{name}}",
      "collapse": "Collapse {{name}}"
    },
    "bell": {
      "channelName": "Alerts"
    }
  },
  "tabs": {
    "workout": "Workout",
    "plan": "Plan",
    "progress": "Progress",
    "profile": "Profile",
    "catalog": "Catalog",
    "admin": "Admin",
    "workoutEyebrow": "Today's session",
    "planEyebrow": "Programming",
    "progressEyebrow": "Charts and reports",
    "profileEyebrow": "Account & maxes",
    "catalogEyebrow": "Exercise catalog",
    "adminEyebrow": "Admin console",
    "progressEmpty": "Log a session first — charts arrive once there's data."
  },
  "shell": {
    "navAria": "Primary navigation"
  },
  "theme": {
    "aria": "Theme",
    "light": "Light",
    "dark": "Dark",
    "auto": "Auto"
  },
  "settings": {
    "restDefaults": {
      "title": "Rest timer defaults",
      "globalLabel": "Global default",
      "globalUnset": "Not set — using {{n}}s",
      "customLabel": "Exercises with a custom default",
      "customEmpty": "No per-exercise overrides. Open the rest banner inside the Logger and tap ⚙ to set one.",
      "customRemoveA11y": "Remove custom rest for {{name}}",
      "clearGlobal": "Reset"
    },
    "hints": {
      "title": "Hints",
      "label": "Show hint tooltips",
      "help": "Hold any button in the logger to see what it does, or tap a column header. Turn off to hide the bubbles that appear on their own."
    },
    "exerciseAgePulse": {
      "label": "Flag a long-unused exercise",
      "help": "A blink on the history pill when you have not done an exercise in a while. Turn it off to keep the age without the blink."
    },
    "effortNudge": {
      "label": "Effort reminder",
      "help": "A rare, gentle pulse on the effort bar while a set waits to be logged."
    },
    "inWorkoutMeter": {
      "label": "In-workout target meter",
      "help": "A strip at the top of the exercise card with the weekly target for the muscles you are training."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Timer sound",
      "soundHelp": "Plays when the rest timer expires.",
      "vibrationLabel": "Vibration",
      "vibrationHelp": "Vibrate when the rest timer expires.",
      "previewButton": "Play",
      "pickerTitle": "Choose a sound",
      "pickerCancel": "Cancel",
      "category": {
        "serious": "Standard",
        "fun": "Fun"
      },
      "soundOptions": {
        "none": "None",
        "chime_crisp": "Chime",
        "ding_dong": "Ding-dong",
        "meditation_bell": "Meditation bell",
        "tada_fanfare": "Ta-da",
        "cartoon_boing": "Boing",
        "ah_yeah": "Yeah!"
      }
    },
    "timerDefaults": {
      "range": "Enter {{min}}–{{max}}s",
      "globalTitle": "Global defaults",
      "restGlobal": "Rest timer",
      "holdGlobal": "Hold timer",
      "saveRow": "Save {{label}}",
      "customLabel": "Per-exercise overrides",
      "customEmpty": "No per-exercise overrides yet. Tap + Add.",
      "unset": "Not set — {{n}}s",
      "add": "+ Add",
      "editRestA11y": "Edit rest override for {{name}}",
      "editHoldA11y": "Edit hold override for {{name}}",
      "editA11y": "Edit timer defaults for {{name}}",
      "isDefault": "default",
      "equalsDefaultHint": "A value left equal to the global default is not saved as an override.",
      "remove": "Remove"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Choose where this build writes",
      "pickLabel": "Write my data to",
      "pickHelp": "Dev build only. Each backend keeps its own session, queues and workout draft — switching never touches the other one.",
      "stageProduction": "PRODUCTION",
      "stageLab": "LABORATORY",
      "liveLabel": "WRITING TO",
      "liveChecking": "Checking…",
      "liveUnknown": "Unknown — the backend did not answer",
      "liveNotProduction": "This is not where your real training lives.",
      "confirmTitle": "Switch backend?",
      "confirmBody": "The app reloads against {{stage}}. You may have to sign in there, and cached lists are dropped.",
      "confirmCta": "Switch",
      "blockedByQueue": "Not switched: some writes have not gone out yet. Get back online and let the queues drain first."
    },
    "animations": {
      "cellularLabel": "Download animations without Wi-Fi",
      "cellularHelp": "Off by default. The animations are there either way: this only lets the app fetch them ahead of time on mobile data, roughly 20 to 30 MB for a programme."
    },
    "crashReports": {
      "label": "Send crash reports",
      "help": "After a crash, the next launch sends our server what failed, where in the code, memory in use, and the app and Android version. Never your workouts, notes, weights or health data."
    }
  },
  "web": {
    "preauth": {
      "tagline": "Strength training that plans around your effort, where your body is right now, and the equipment you actually have.",
      "status": "In development. Registration is closed.",
      "contactLabel": "Access or information"
    },
    "crash": {
      "body": "The app hit an unexpected error. Your saved data is safe — reload to continue.",
      "reload": "Reload",
      "retryBody": "The app hit an unexpected error. Your saved data is safe — try again, and if this screen comes back, send us the message below.",
      "retry": "Try again"
    },
    "postSession": {
      "headlineLabelPR": "NEW E1RM",
      "headlineLabelDelta": "BIG JUMP +{{delta}}",
      "headlineLabelSolid": "SOLID SESSION",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} sets",
      "blockE1rm": "E1RM",
      "fromSet": "from {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Duration",
      "blockDensity": "Density",
      "barsTitle": "Work by muscle",
      "bodyTitle": "Muscles worked",
      "sharing": "Preparing…",
      "shareCta": "Share session card"
    }
  },
  "muscle": {
    "quadriceps": "Quads",
    "hamstrings": "Hamstrings",
    "glutes": "Glutes",
    "adductors": "Adductors",
    "abductors": "Abductors",
    "calves": "Calves",
    "core": "Core",
    "obliques": "Obliques",
    "erectors": "Lower back",
    "pectoralis": "Chest",
    "anterior-delts": "Front delts",
    "lateral-delts": "Side delts",
    "triceps": "Triceps",
    "lats": "Lats",
    "rhomboids": "Upper back",
    "rear-delts": "Rear delts",
    "traps": "Traps",
    "biceps": "Biceps",
    "forearms": "Forearms"
  },
  "experience": {
    "menuLabel": "Active profile",
    "athlete": "Athlete",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Exercise",
    "targetKeyExercise": "Exercise",
    "targetRefAvg": "~{{n}}/wk avg",
    "targetRefNone": "No data in the last 4 weeks",
    "targetRefProgram": "program prescribes ~{{n}}/wk",
    "targetUseAvg": "Use average",
    "targetUseProgram": "Use program value",
    "projectionTitle": "How targets land",
    "projectionWeek": "Week {{n}}",
    "projectionContext": "Sets / load the program prescribes in week {{n}}.",
    "projectionTarget": "Target",
    "projectionWeekTotal": "Week",
    "projectionRamp": "Cycle",
    "projectionWeekShort": "W{{n}}",
    "projectionEmpty": "Not scheduled",
    "targetsTitle": "Weekly targets",
    "targetsEmptyTitle": "No weekly targets",
    "targetsEmptySub": "Add one to light up the level meter.",
    "targetAdd": "Add target",
    "targetRemove": "Remove target {{name}}",
    "targetCollapse": "Collapse",
    "targetAxis": "Axis",
    "targetAxisMuscle": "Muscle",
    "targetMetric": "Metric",
    "targetMetricHardSets": "Hard sets",
    "targetMetricTonnage": "Tonnage",
    "targetMetricReps": "Reps",
    "targetKeyMuscle": "Muscle",
    "targetValue": "Weekly goal",
    "targetUnitHardSets": "hard sets",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "reps",
    "targetBand": "±{{pct}}%",
    "targetNotScored": "not in meter yet",
    "targetNotScoredNote": "This target type isn't scored by the level meter yet.",
    "targetBandLabel": "Tolerance",
    "targetBandAsym": "−{{lo}}% / +{{hi}}%",
    "targetBandBelow": "Percent below goal",
    "targetBandAbove": "Percent above goal",
    "targetBandRange": "Below 0–99%, above 0% or more.",
    "compose": "Compose",
    "preview": "Preview",
    "addExercises": "Add exercises",
    "editingBlockDay": "Editing D{{d}} — Update applies to this day (tick more days to apply there too)",
    "editingRampDay": "Weekly ramp on D{{d}} — Update applies to the selected weeks, this day only",
    "segments": "Segments",
    "rampSwitchHint": "Update or Cancel before switching segment",
    "setupHint": "Set the starting shape — you can add or remove days and change the weeks later in the editor.",
    "repsHint": "Reps “5+” = AMRAP: at least 5, then as many as possible.",
    "repsHintA11y": "How reps are written",
    "addingWeek": "New week W{{n}} — Update adds it to this exercise",
    "cloneWeek": "Clone week…",
    "cloneWeekFrom": "From",
    "cloneWeekApply": "Clone",
    "cloneWeekConflict": "{{name}} already has content in W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Nothing to clone — pick a filled source week and at least one target",
    "editingWeekDay": "Editing W{{n}} on D{{d}} only — Update breaks it out of its segment",
    "perWeek": "Per week",
    "dupExercise": "{{name}} is already on D{{day}} in the selected weeks",
    "days": "Days",
    "weeks": "Weeks",
    "setNote": "Set note",
    "removeExercise": "Remove exercise",
    "replaceExercise": "Replace exercise",
    "clone": "Clone",
    "remove": "Remove",
    "removeConfirm": "Confirm? ({{n}} cells)",
    "verbatim": "Advanced slot (multi-variant) — preserved as-is, not editable here",
    "metaWeeks_one": "{{count}} week",
    "metaWeeks_other": "{{count}} weeks",
    "tabPlan": "Plan",
    "importPlanHint": "Its exercises are added to the day you are editing, in every week of the cycle.",
    "importPlanEmpty": "No saved plans yet.",
    "importPlanMeta_one": "{{count}} exercise",
    "importPlanMeta_other": "{{count}} exercises",
    "importPlanAction_one": "Add {{name}} to this day ({{meta}}), in the one week of the cycle",
    "importPlanAction_other": "Add {{name}} to this day ({{meta}}), in all {{count}} weeks of the cycle",
    "removeSlotConfirmTitle_one": "Remove from that week?",
    "removeSlotConfirmTitle_other": "Remove from all {{count}} weeks?",
    "removeSlotConfirm_one": "Remove {{name}} from this day? Its prescription for that week is deleted.",
    "removeSlotConfirm_other": "Remove {{name}} from this day? This deletes its prescription in all {{count}} weeks, not just the week shown.",
    "metaDays_one": "{{count}} training day",
    "metaDays_other": "{{count}} training days",
    "gridToggle": "Intensity grid",
    "addDay": "Add day",
    "removeDay": "Remove day D{{n}}",
    "removeDayConfirm": "Confirm — remove day D{{n}}?",
    "dayEmpty": "No exercises on this day yet. Add one to build it.",
    "prescribeDayEmpty": "No exercises on this day yet.",
    "prescribeFocusEmpty": "Select an exercise above to prescribe its sets.",
    "prescribeViewMatrix": "Matrix",
    "prescribeViewEditor": "Editor",
    "prescribeViewGroup": "Switch view",
    "checkEmptyCell": "W{{w}}·D{{d}} has no exercises",
    "checkPctNoMax": "{{name}} uses %MAX without a saved MAX",
    "exerciseNote": "Exercise note",
    "exerciseNotePlaceholder": "Note for this exercise (shown while logging)",
    "panelHint": "Tap an exercise to edit, clone or remove",
    "warnLine_one": "{{count}} warning",
    "warnLine_other": "{{count}} warnings",
    "adjacencyWarnLine_one": "{{count}} muscle-recovery warning",
    "adjacencyWarnLine_other": "{{count}} muscle-recovery warnings",
    "adjacencyWarnItem": "{{muscle}} trained on adjacent days ({{count}}×)",
    "publishChecklist": "Open warnings (publishing anyway is fine)",
    "publishClean": "No open warnings.",
    "weekShort": "Week",
    "placed": "on",
    "notPlaced": "off",
    "placementHint": "Hold a cell to place or remove {{exercise}} there.",
    "addWeek": "Add empty week",
    "removeWeek": "Remove week",
    "holdDayToRemoveHint": "Hold a day to remove it",
    "holdWeekToRemoveHint": "Hold a week to remove it",
    "holdAddWeekToCloneHint": "Hold W ＋ to repeat this week",
    "holdCellToPlaceHint": "Hold a cell to place the exercise there",
    "cloneWeekAction": "Add a week repeating this one",
    "removeWeekConfirm": "Confirm — drop this week and its sets",
    "coverageTitle": "Coverage — hard sets/week",
    "coverageHint": "Full-cycle average. Zero shows here before you've trained it.",
    "rosterNotThisWeek": "not in this week",
    "dayWeekCursor": "D{{d}}·W{{w}}",
    "prescribeNotThisWeek": "{{exercise}} is not scheduled on {{cursor}}.",
    "prescribeLockedNewFields": "{{exercise}} has sets per round, a rep range or mixed load axes. Read only here: edit it on the phone.",
    "prescribePlaceHere": "Place on {{cursor}}",
    "placementAddHere": "Place {{exercise}} here",
    "placementRemoveHere": "Remove {{exercise}} from here",
    "weekCue": "Week {{pos}} of {{total}}. Tap for the next week.",
    "weekCuePrev": "Previous week",
    "targetRefThisWeek": "this wk so far {{n}}",
    "setNoteChip": "Note",
    "setNoteChipA11y": "Write a note on a set of this round",
    "weekMenuHint": "Opens the round menu",
    "weekMenuHoldHint": "Tap for the round menu. Hold to remove the round.",
    "setNoteChipLocked": "Shown while a set has a note",
    "importProgramBack": "Back to the programs",
    "importProgramDayHint": "Its exercises are added at the end of the day you are editing. Extra rounds are left out, missing ones stay empty.",
    "importProgramDayAction": "Add {{day}} of {{program}} to this day ({{meta}})",
    "importProgramEmpty": "No other programs yet.",
    "importProgramOpen": "{{name}} ({{meta}}): choose a day",
    "importProgramDays_one": "{{count}} day",
    "importProgramDays_other": "{{count}} days",
    "importProgramRounds_one": "{{count}} round",
    "importProgramRounds_other": "{{count}} rounds"
  },
  "gym": {
    "setPlace": "Where?",
    "whichPlace": "Where are you training?",
    "newPlace": "Add place",
    "fallback": "Default",
    "chipA11y": "Training place",
    "footnote": "Sorts what you see first. Never shared with a coach.",
    "namePlaceTitle": "Name this place",
    "namePlaceHint": "Place name",
    "namePlaceSave": "Use this place",
    "pinPlace": "Set {{place}} as your default place",
    "unpinPlace": "Remove {{place}} as your default place",
    "pinHint": "Remembers this as the place you usually train at.",
    "unpinHint": "Forgets your default place.",
    "pinErrorTitle": "Not saved",
    "pinErrorBody": "Your default place is unchanged."
  },
  "inbox": {
    "emptyTitle": "Inbox",
    "emptyBody": "You're all caught up.",
    "accept": "Accept",
    "decline": "Decline",
    "acknowledge": "Got it",
    "feedback": {
      "statusChanged": {
        "title": "Your report",
        "body": "Your report was marked {{status}}."
      }
    },
    "sessionCorrection": {
      "orphaned": {
        "title": "Correction waiting on another phone",
        "body": "You corrected a workout, but it was deleted on another device. Your correction is still on the phone where you saved it: open Notifications there (the bell) and tap Save as new."
      }
    },
    "maxBump": {
      "raise": {
        "title": "New MAX",
        "body": "{{exercise}}: your workout points to a new MAX of {{suggestedKg}}."
      },
      "lower": {
        "title": "Your MAX may have dropped",
        "body": "{{exercise}}: your workout points to {{suggestedKg}}. Your MAX is {{currentKg}}, set {{weeks}}."
      },
      "confirm": "Confirm",
      "lowerTo": "Lower to {{suggestedKg}}",
      "skip": "Skip",
      "keep": "Keep {{currentKg}}",
      "badDay": "Bad day",
      "thisWeek": "this week",
      "weeksAgo_one": "{{count}} week ago",
      "weeksAgo_other": "{{count}} weeks ago",
      "badDayHint": "Keeps your MAX and stays quiet about this exercise until the drop shows up again."
    },
    "bodyweight": {
      "missing": {
        "title": "Your bodyweight is missing",
        "body": "Bodyweight exercises need your weight to work out load and volume. Add it in Me → Measurements.",
        "cta": "Add weight",
        "dismiss": "Don't remind me"
      }
    },
    "coachEdge": {
      "invitedByCoach": {
        "title": "Coaching invite",
        "body": "A coach has invited you to be their athlete."
      },
      "invitedByAthlete": {
        "title": "Coaching request",
        "body": "An athlete has invited you to be their coach."
      }
    },
    "assignment": {
      "program": {
        "title": "New program",
        "body": "{{from}} wants to assign you {{itemName}}.",
        "bodySelf": "You sent yourself {{itemName}} as coach — accept or decline it below."
      },
      "plan": {
        "title": "New workout",
        "body": "{{from}} wants to assign you {{itemName}}.",
        "bodySelf": "You sent yourself {{itemName}} as coach — accept or decline it below."
      },
      "accepted": {
        "title": "Assignment accepted",
        "body": "{{itemName}} was accepted."
      },
      "rejected": {
        "title": "Assignment declined",
        "body": "{{itemName}} was declined."
      }
    },
    "followedProgram": {
      "updated": {
        "title": "Program updated",
        "body": "{{itemName}} was changed by its author."
      },
      "removed": {
        "title": "Program no longer shared",
        "body": "You no longer have access to {{itemName}}."
      },
      "gone": {
        "title": "Program deleted",
        "body": "{{itemName}} was deleted by its author."
      }
    },
    "followedPlan": {
      "updated": {
        "title": "Plan updated",
        "body": "{{itemName}} was changed by its author."
      },
      "removed": {
        "title": "Plan no longer shared",
        "body": "You no longer have access to {{itemName}}."
      },
      "gone": {
        "title": "Plan deleted",
        "body": "{{itemName}} was deleted by its author."
      }
    },
    "actionError": "That didn't go through. Try again.",
    "actionErrorItemGone": "This offer is no longer available. Use Decline to clear the card.",
    "bell": {
      "label": "Alerts",
      "title": "Notifications",
      "close": "Close notifications",
      "a11y_one": "{{count}} notification",
      "a11y_other": "{{count}} notifications"
    },
    "actionErrorNoLongerAssigned": "The sender withdrew this. Use Decline to clear the card.",
    "actionErrorWrongParty": "Only the person who was invited can answer this.",
    "actionErrorFanout": "It could not be added to your library. Try again.",
    "loadError": "Couldn't load your notifications.",
    "retry": "Try again",
    "local": {
      "eyebrow": "This phone",
      "action": {
        "open": "Open",
        "hide": "Hide",
        "retry": "Retry",
        "details": "Details",
        "retrying": "Trying again…",
        "resume": "Resume",
        "discard": "Discard",
        "merge": "Merge",
        "sendSupport": "Send to support",
        "sending": "Sending…"
      },
      "hcNoConsent": {
        "title": "Health Connect disconnected",
        "body": "Your account holds no consent for Health Connect, so this phone stopped importing. What it already read waits here until you connect again."
      },
      "hcRefusalTitle": {
        "granted": "Consent not recorded",
        "revoked": "Withdrawal not recorded",
        "revokedElsewhere": "Health Connect disconnected"
      },
      "hcDriftTitle": {
        "deviceOff": "Health Connect not allowed on this phone",
        "undated": "Confirm your Health Connect consent",
        "noRecord": "Confirm your Health Connect consent"
      },
      "hcUpdate": {
        "title": "Update Health Connect",
        "body": "$t(brand.product) cannot read Health Connect until you update its app."
      },
      "stuckWrites": {
        "title_one": "{{count}} save didn't go through",
        "title_other": "{{count}} saves didn't go through",
        "body": "This phone already tried again on its own. Retry now, or open the details to see what did not go through.",
        "bodyStill": "Tried again just now: still not through. Open the details to see what the server answered for each one."
      },
      "draftResume": {
        "title": "Workout not saved",
        "body": "The app closed during your workout on {{date}}, and it is still on this phone. To discard it, use Discard in Notifications. Tap to resume.",
        "discardTitle": "Discard this workout?",
        "discardBody": "The sets you logged on {{date}} were never saved. Discarding deletes them from this phone for good."
      },
      "workoutRecovery": {
        "title": "Unsaved workout from {{date}}",
        "titleCorrection": "Correction from {{date}} not saved",
        "body": "The app closed before this workout was saved, and this phone kept it. Sets done: {{done}} of {{total}}. Save it as a new workout, merge it into one from the same day, or discard it.",
        "bodySent": "Sent to support. The workout stays on this phone until you save it, merge it or discard it."
      }
    },
    "actionErrorOffline": "This needs a connection. Reconnect and try again."
  },
  "editorV3": {
    "addExerciseToRound": "Add {{name}} to W{{n}}",
    "addToRound": "Add to W{{n}}",
    "alignTrimHint": "Removes the extra sets at the end. Undo in the message brings them back.",
    "backToDay": "Back to {{day}}",
    "clear": "Clear day",
    "clearBody_one": "{{count}} exercise will be removed.",
    "clearBody_other": "{{count}} exercises will be removed.",
    "clearTitle": "Clear {{day}}?",
    "copyName": "{{name}} (copy)",
    "copyOnto": "Copy onto…",
    "copyOntoBody_one": "{{day}} has {{count}} exercise. A copy of {{from}} replaces it.",
    "copyOntoBody_other": "{{day}} has {{count}} exercises. A copy of {{from}} replaces them.",
    "copyOntoFootnote": "The day you pick loses what it has now.",
    "copyOntoQuestion": "Copy {{day}} onto which day?",
    "copyOntoTitle": "Replace {{day}}?",
    "copyRoundBody_one": "{{round}} has {{count}} exercise across the days. A copy of {{from}} replaces it.",
    "copyRoundBody_other": "{{round}} has {{count}} exercises across the days. A copy of {{from}} replaces them.",
    "copyRoundFootnote": "The round you pick loses what it has now, in every day.",
    "copyRoundQuestion": "Copy {{round}} onto which round?",
    "copyRoundTitle": "Replace {{round}}?",
    "dayChipA11y": "Day {{n}} {{name}}",
    "dayCleared": "{{day}} cleared",
    "dayCopied": "Copied onto {{day}}",
    "dayDuplicated": "Day duplicated",
    "dayEmpty": "No exercises in {{day}} yet.",
    "dayMenuA11y": "{{day}}, day menu",
    "dayName": "Day name",
    "dayRemoved": "{{day}} removed",
    "daysA11y": "Days",
    "dissolveSuperset": "Dissolve superset",
    "duplicateDay": "Duplicate day",
    "duplicateRound": "Duplicate round",
    "exerciseMenuA11y": "{{name}}, menu",
    "exerciseRemoved": "{{name}} removed",
    "exerciseTipA11y": "About {{name}}",
    "historyLoad": "last time",
    "lensA11y": "Read the day by",
    "lensExercises": "Exercises",
    "lensRound": "Per round",
    "moveDayEarlier": "Move earlier",
    "moveDayLater": "Move later",
    "moveRoundEarlier": "Move earlier",
    "moveRoundLater": "Move later",
    "notInRound": "Not in this round",
    "offRoundOnlyInDay": "The only exercise of this day in W{{n}}",
    "offRoundOnlyRound": "It runs in no other round",
    "remove": "Remove",
    "removeDay": "Remove day",
    "removeDayBody_one": "The day goes with its {{count}} exercise.",
    "removeDayBody_other": "The day goes with its {{count}} exercises.",
    "removeDayEmptyBody": "The day is empty.",
    "removeDayTitle": "Remove {{day}}?",
    "removeExerciseBody": "It leaves this day in every round.",
    "removeExerciseTitle": "Remove {{name}}?",
    "removeFromRound": "Remove from W{{n}}",
    "removeRound": "Remove W{{n}}",
    "removeRoundBody": "Its sets leave every day. The rounds after it move one place earlier.",
    "removeRoundTitle": "Remove W{{n}}?",
    "removedFromRound": "{{name}} removed from W{{n}}",
    "renameDay": "Rename",
    "renameSuperset": "Rename superset",
    "renameTitle": "Rename {{day}}",
    "replace": "Replace",
    "replaceExercise": "Replace exercise",
    "roundA11y": "Round {{n}}: {{line}}",
    "roundChipA11y": "Round {{n}}",
    "roundCopied": "Copied onto {{round}}",
    "roundDuplicated": "W{{n}} duplicated",
    "roundLastInDay": "{{name}} is the only exercise of this day in W{{n}}. Remove the exercise or the round instead.",
    "roundLastOfExercise": "W{{n}} is the only round {{name}} runs in. Remove the exercise instead.",
    "roundScope": "Reps, load and seconds change this round only. Axis, time bound and sets change every round.",
    "roundScopeLens": "Reps, load, seconds and sets change this round only. Axis and time bound change every round.",
    "alignPadEachRound": "+ Pad to the longest in each round",
    "alignTrimEachRound": "− Trim to the shortest in each round",
    "setsTrimmedEachRound": "Superset made, sets trimmed to the shortest in each round",
    "roundSetAdded": "W{{n}}: one set more",
    "roundSetRemoved": "W{{n}}: one set less",
    "roundSetCount_one": "W{{n}}: {{count}} set",
    "roundSetCount_other": "W{{n}}: {{count}} sets",
    "roundOnlySet": "W{{n}} has one set left. Take the exercise out of the round instead.",
    "roundMixedBound": "W{{n}} unchanged: a timed set and a reps set would swap places.",
    "setRangeA11y": "{{lo}} to {{hi}} sets of",
    "roundsA11y": "Rounds",
    "secondsUnit": "s",
    "setsTrimmed": "Superset made, sets trimmed to {{n}}",
    "supersetN": "Superset {{n}}",
    "supersetName": "Superset name",
    "supersetNameHint": "Leave it empty to number it again.",
    "supersetWithNext": "Superset with the next exercise",
    "variants": "Alternates with {{names}}. Not editable here yet.",
    "problems_one": "{{count}} problem",
    "problems_other": "{{count}} problems",
    "problemPrev": "Previous problem, {{n}} of {{total}}",
    "problemNext": "Next problem, {{n}} of {{total}}",
    "problemGoA11y": "Problem {{n}} of {{total}}, {{where}}: {{message}}. Go there",
    "select": "Select",
    "selectDone": "Done",
    "selectA11y": "Select exercises in {{day}}",
    "selectDoneA11y": "Done selecting in {{day}}",
    "copyToOtherDays": "Copy to other days",
    "copyTo": "Copy to…",
    "copyToDaysQuestion": "Copy {{what}} to which days?",
    "copyToDaysFootnote": "Each day gets its own copy, at the end. A superset comes whole.",
    "copyToDaysNone": "Copy",
    "copyToDaysConfirm_one": "Copy to {{count}} day",
    "copyToDaysConfirm_other": "Copy to {{count}} days",
    "copiedToDays": "Copied to {{days}}.",
    "addedOneToDays": "{{name}} added to {{days}}.",
    "addedManyToDays_one": "{{count}} exercise added to {{days}}.",
    "addedManyToDays_other": "{{count}} exercises added to {{days}}.",
    "addedAgain_one": "{{days}} already had it: now it is there twice.",
    "addedAgain_other": "{{days}} already had some of them: now they are there twice.",
    "valuesFromRole": "Values from the day's role.",
    "removeSelectedTitle_one": "Remove {{count}} exercise?",
    "removeSelectedTitle_other": "Remove {{count}} exercises?",
    "removeSelectedBody_one": "It leaves this day in every round.",
    "removeSelectedBody_other": "They leave this day in every round.",
    "selectedRemoved_one": "{{count}} exercise removed",
    "selectedRemoved_other": "{{count}} exercises removed",
    "nExercises_one": "{{count}} exercise",
    "nExercises_other": "{{count}} exercises",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_other": "{{count}} selected",
    "programDayImported": "{{day}} of {{program}} added.",
    "roundsDropped_one": "{{rounds}} left out: this program has fewer rounds.",
    "roundsDropped_other": "{{rounds}} left out: this program has fewer rounds.",
    "daysFull_one": "{{days}} would pass {{max}} exercises: nothing added there.",
    "daysFull_other": "{{days}} would pass {{max}} exercises: nothing added there.",
    "importNothing": "Nothing added: {{day}} has no exercise in this program's rounds.",
    "roundTypeMenu": "Round type…",
    "roundTypeQuestion": "What kind of round is {{round}}?",
    "roundTypeNormal": "Normal",
    "roundTypeDeload": "Deload",
    "roundTypeTest": "Test",
    "roundTypedA11y": "Round {{n}}, {{type}}: {{line}}",
    "roundChipTypedA11y": "Round {{n}}, {{type}}",
    "roundTypeSet": "W{{n}} {{type}}. Applied to: the whole program.",
    "roundRemovedByRules": "W{{n}} removed. Cells by hand after it move with their round.",
    "roundTypeFootnoteRules": "The type holds for the whole program. Each exercise gets its effect from its rule.",
    "rule": {
      "name": {
        "constant": "Constant",
        "effortRamp": "Effort ramp",
        "tetrad": "Tetrad, test and deload",
        "perSet": "Per set",
        "linear": "Linear",
        "repsThenLoad": "Reps, then load",
        "triple": "Triple progression",
        "timed": "Timed",
        "history": "Last time",
        "waves": "Waves",
        "blocks": "In blocks",
        "pyramid": "Pyramid",
        "repsUp": "Rising reps",
        "topBackoff": "Top and back-off"
      },
      "preset": {
        "linearKg": "Linear in kg"
      },
      "manual": "Values by hand",
      "manualBody": "No rule recognized. Every cell is yours to edit.",
      "title": "Rule · {{name}}",
      "perRound": "{{step}} per round",
      "upTo": "{{what}} up to {{cap}}",
      "ramp_one": "from {{from}} to {{to}} over {{count}} round",
      "ramp_other": "from {{from}} to {{to}} over {{count}} rounds",
      "cycle": "in turn {{values}}",
      "blocks_one": "{{count}} block, starting again",
      "blocks_other": "{{count}} blocks, each starting again",
      "threshold": "reps {{min}} to {{max}} by {{step}}",
      "thenSets": "then sets up to {{n}}",
      "thenLoad": "then {{step}}",
      "repsStep": "{{step}} reps",
      "amrapInTest": "last set AMRAP in the test round",
      "testLast": "test round {{step}} on the last set",
      "testTop": "test round {{step}} on the top sets",
      "test": "test round {{step}}",
      "deloadPct": "deload at {{pct}}%",
      "deload": "deload {{step}}",
      "deloadSets_one": "{{count}} set fewer in deload",
      "deloadSets_other": "{{count}} sets fewer in deload",
      "same": "the same every round",
      "applied": "Rule changed. Applied to: the rounds that follow it.",
      "appliedMany_one": "Rule applied to {{count}} exercise. Applied to: the rounds that follow it.",
      "appliedMany_other": "Rule applied to {{count}} exercises. Applied to: the rounds that follow it.",
      "rowRealigned": "Row realigned with the rule.",
      "roundRealigned": "{{round}} realigned with the rule.",
      "blockAdded": "{{from}} to {{to}} added.",
      "byHand": "{{round}} set {{set}}: written by hand. Applied to: here only.",
      "followsAgain": "Follows the rule again.",
      "handCount_one": "{{count}} cell by hand",
      "handCount_other": "{{count}} cells by hand",
      "handDone_one": "{{count}} by hand in the rounds done",
      "handDone_other": "{{count}} by hand in the rounds done",
      "realign": "Realign",
      "realignHint": "Every cell back on the rule",
      "change": "Change rule",
      "byHandMark": "by hand",
      "realignRound": "Realign {{round}} with the rule",
      "typedStays": "A value typed here stays yours: the rule does not write over it.",
      "addBlock_one": "{{count}} round",
      "addBlock_other": "{{count}} rounds",
      "blockAdd_one": "Add {{count}} round",
      "blockAdd_other": "Add {{count}} rounds",
      "blockTitle": "Add {{from}}-{{to}}",
      "blockShape": "One more tetrad: two normal rounds, one test round, one deload round.",
      "blockCarry": "Load and rep rows carry on from where they were.",
      "blockEffort": "Effort rows repeat their shape. The load rises with the MAX measured in the test round.",
      "sheetTitle": "Rule",
      "sheetTitleMany_one": "Rule for {{count}} exercise",
      "sheetTitleMany_other": "Rule for {{count}} exercises",
      "apply": "Apply",
      "presets": "Presets",
      "changes": "changes",
      "roundsChange_one": "{{count}} round changes.",
      "roundsChange_other": "{{count}} rounds change.",
      "alsoTitle": "Also apply to:",
      "alsoSame": "Same exercise, other days",
      "alsoOthers": "Other exercises",
      "alsoShowAll": "Show all",
      "alsoShowLess": "Show fewer",
      "alsoEach": "Each exercise keeps its own starting numbers.",
      "lostTest": "No AMRAP in the test round.",
      "lostTestMany": "No AMRAP in the test round for: {{names}}.",
      "lostDeload": "No deload.",
      "lostDeloadMany": "No deload for: {{names}}.",
      "stallNever": "The load never goes up in these rounds.",
      "stallAt": "The load does not go up in these rounds. First rise: {{round}}.",
      "noRoundChanges": "No round changes.",
      "handStays_one": "The {{count}} cell by hand stays.",
      "handStays_other": "The {{count}} cells by hand stay.",
      "supersetFollows": "The superset takes the same set count.",
      "undoable": "Undo brings it back.",
      "waveLess": "One value less in the cycle",
      "waveMore": "One value more in the cycle",
      "selectionAction": "Rule",
      "field": {
        "sets": "Sets",
        "reps": "Reps",
        "effort": "Effort",
        "step": "Step per round",
        "cap": "Cap",
        "load": "From",
        "deloadPct": "Deload",
        "repsMin": "Reps min",
        "repsMax": "Reps max",
        "repsStep": "Reps step",
        "loadStep": "Then",
        "seconds": "Seconds",
        "efforts": "Efforts of the cycle",
        "setsMax": "Sets up to",
        "repsSetStep": "Reps per set",
        "loadSetStep": "Load per set",
        "backoffSets": "Back-off sets",
        "topEffort": "Top set effort",
        "backoffEffort": "Back-off effort",
        "off": "None"
      },
      "backoff": "back-off sets {{step}}",
      "eachSet": "each set {{steps}}",
      "handAxisResets_one": "{{count}} value typed by hand is replaced: the new rule uses another unit.",
      "handAxisResets_other": "{{count}} values typed by hand are replaced: the new rule uses another unit.",
      "lockedStay": "Done up to {{round}}: those rounds stay as they are.",
      "reference": "ref. ≈ {{load}}",
      "pickPreset": "No preset writes this rule. Pick one to replace it.",
      "pickPresetManual": "No rule recognized. Pick a preset to replace the values by hand.",
      "blockFull": "A program holds at most {{max}} rounds: there is no room for another tetrad."
    },
    "tetrad": {
      "scratchTitle": "From scratch",
      "scratchBody": "One empty day and four rounds.",
      "rounds": "Rounds",
      "roundsA11y_one": "{{count}} round",
      "roundsA11y_other": "{{count}} rounds",
      "perWeek": "Sessions a week",
      "perWeekA11y_one": "{{count}} session a week",
      "perWeekA11y_other": "{{count}} sessions a week",
      "dayEmpty": "No exercise: the day needs at least one.",
      "removeExercise": "Take out {{name}}",
      "back": "Back",
      "needName": "Give the program a name first.",
      "needDay": "Each day needs at least one exercise: put one back.",
      "putBack": "Put back {{name}}",
      "takenOut": "taken out"
    },
    "model": {
      "fromModel": "From a model",
      "fromModelBody": "The model writes the days and the rounds. You choose the level, the time per session and the exercises.",
      "fromTemplate": "From a template",
      "fromTemplateBody": "A copy of a public program, to change as you like.",
      "noModel": "No model yet.",
      "noTemplate": "No template yet.",
      "loading": "Loading…",
      "loadError": "Could not load. Tap to try again.",
      "level": "Level",
      "minutes": "Minutes per session",
      "minutesA11y_one": "{{count}} minute",
      "minutesA11y_other": "{{count}} minutes",
      "minutes45": "No optional exercises, and one set fewer on the accessories.",
      "minutes60": "No optional exercises.",
      "minutes75": "Every exercise of the model.",
      "rotateHint_one": "The day repeats: a round lasts {{length}} days.",
      "rotateHint_other": "The {{count}} days take turns: a round lasts {{length}} days.",
      "blocksHint_one": "The model runs once.",
      "blocksHint_other": "The model runs {{count}} times: each time starts again a step higher.",
      "swapA11y_one": "{{name}}. Swap it for the alternative",
      "swapA11y_other": "{{name}}. Swap it for one of {{count}} alternatives",
      "alternatives": "Alternatives",
      "alternativesCount_one": "{{count}} alternative",
      "alternativesCount_other": "{{count}} alternatives"
    },
    "roundLocked": "W{{n}} is done: it stays as it is.",
    "lock": {
      "unlock": "Unlock",
      "unlockA11y": "Unlock the rounds already done",
      "title": "Unlock the rounds done?",
      "body": "The sessions already done read their prescription from the program: changing {{rounds}} changes what the history says was prescribed. They stay unlocked until you close the editor.",
      "done": "done",
      "doneA11y": "done, read only",
      "offDone": "Not in this round, and it is done: unlock at the top to add the exercise.",
      "readOnly": "{{round}} is done: read only. Unlock it at the top of the editor.",
      "range": "{{from}}-{{to}}"
    },
    "grid": {
      "structure": "Structure",
      "exercise": "Exercise",
      "lensEffort": "Effort",
      "lensReps": "Reps",
      "lensLoad": "Load",
      "lensSets": "Sets",
      "dayPeak": "Peak",
      "dayPeakA11y": "Peak: {{band}}",
      "setsFieldA11y": "{{name}}, {{round}}: sets in this round",
      "setsNote": "Type the sets of one round: the change holds for that round only, on the whole superset.",
      "lensA11y": "Show in the grid",
      "roundHeadA11y": "{{round}}, round menu",
      "cellA11y": "{{name}}, {{round}}: {{line}}",
      "note": "One lens at a time. Load shows the weight written, or ≈ the load from your MAX for a row at effort. Tap a cell to open it on the right.",
      "pickExercise": "Pick an exercise in the grid to see it here."
    }
  }
}
